<template>
<div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
        {{ text }}
        <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-snackbar :top="y === 'top'" v-model="errorSnackbar">
        {{ text }}
        <v-btn color="red" class="white--text" flat @click="errorSnackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat dense color="white">
        <v-btn icon @click="routeToServiceAccount()">
            <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-chip small v-if="serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&serviceAccount.isSuspended&&serviceAccount.isActive" class="white--text" color="orange">Suspended</v-chip>
        <v-chip small v-else-if="serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&(new Date(serviceAccount.fnoDeactivationDate)>new Date()||serviceAccount.fnoDeactivationDate==null)" class="white--text" color="light-green">Active</v-chip>
        <v-chip small v-else-if="serviceAccount.fnoActivationDate!==null&&serviceAccount.fnoDeactivationDate!=null&&(new Date(serviceAccount.fnoDeactivationDate)<new Date())" class="white--text" color="red">Inactive</v-chip>
        <v-chip small v-else-if="serviceAccount.fnoActivationDate==null||new Date(serviceAccount.fnoActivationDate)>new Date()" class="white--text" color="blue">Pending</v-chip>
        <v-toolbar-title>
            {{ serviceAccount.circuitNumber }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <div v-if="serviceAccount&&serviceAccount.device&&serviceAccount.deviceBridgeId&&serviceAccount.device.isU2000">
            <v-btn @click="suspendServices(serviceAccount)" round small class="white--text" color="red" v-if="allOpenTickets.filter(x=>x.ticketCategoryItem.name === 'U2000: Deactivate Service').length==0&&serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&(new Date(serviceAccount.fnoDeactivationDate)>new Date()||serviceAccount.fnoDeactivationDate==null)&&!serviceAccount.isSuspended">Suspend</v-btn>
            <v-btn @click="reactivateServices(serviceAccount)" round small class="white--text" color="light-green" v-else-if="allOpenTickets.filter(x=>x.ticketCategoryItem.name === 'U2000: Activate Service').length==0&&serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&serviceAccount.isSuspended&&serviceAccount.isActive">Reactivate</v-btn>
            <v-chip v-else-if="serviceAccount.fnoActivationDate!==null&&serviceAccount.fnoDeactivationDate!=null&&(new Date(serviceAccount.fnoDeactivationDate)<new Date())" class="white--text" color="red">Inactive</v-chip>
        </div> -->

         <div v-if="serviceAccount&&serviceAccount.device&&serviceAccount.deviceBridgeId&&serviceAccount.device.isU2000">
            <v-chip small @click="suspendServices(serviceAccount)" round class="white--text" color="red" v-if="allOpenTickets.filter(x=>x.ticketCategoryItem.name === 'U2000: Deactivate Service').length==0&&serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&(new Date(serviceAccount.fnoDeactivationDate)>new Date()||serviceAccount.fnoDeactivationDate==null)&&!serviceAccount.isSuspended">Suspend</v-chip>
            <v-chip small @click="reactivateServices(serviceAccount)" round class="white--text" color="light-green" v-else-if="allOpenTickets.filter(x=>x.ticketCategoryItem.name === 'U2000: Activate Service').length==0&&serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&serviceAccount.isSuspended&&serviceAccount.isActive">Reactivate</v-chip>
            <v-chip small color="light-green" @click="reactivationRequest()" v-else-if="serviceAccount.fnoActivationDate!==null&&serviceAccount.fnoDeactivationDate!=null&&(new Date(serviceAccount.fnoDeactivationDate)<new Date())&&!serviceAccount.isSuspended" class="white--text">Reactivation Request</v-chip>
        </div>

    </v-toolbar>
    <v-divider></v-divider>
    <v-divider></v-divider>
    <v-layout justify-start wrap>
        <v-flex xs12 sm8>
            <v-layout justify-start wrap>
                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader>
                        <v-subheader style="background: #f0f0f0"> Network Operator</v-subheader>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon v-if="serviceAccount.location">location_on</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{ serviceAccount.location.locationDescription }}
                                </v-list-tile-title>
                                <v-list-tile-subtitle style="fontSize: 14px">
                                    <span class="grey--text font-weight-light">
                                        {{ serviceAccount.location.locationNetwork.name }}
                                    </span>
                                    <v-chip style="height: 18px" class="white--text" color="green" v-if="serviceAccount.location&&serviceAccount.location.locationNetwork.networkStatus=='Live'">Live</v-chip>
                                    <v-chip style="height: 18px" class="white--text" color="blue" v-if="serviceAccount.location&&serviceAccount.location.locationNetwork.networkStatus=='In Progress'">In Progress</v-chip>
                                    <v-chip style="height: 18px" class="white--text" color="orange" v-if="serviceAccount.location&&serviceAccount.location.locationNetwork.networkStatus=='Planned'">Planned</v-chip>
                                </v-list-tile-subtitle>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>bar_chart</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{serviceAccount.packagesIsp.packagesFno.packageCode}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    <v-layout align-center justify-start style="fontSize: 14px">
                                        <v-icon style="height: 15px" color="light-green">arrow_drop_down</v-icon>
                                        {{serviceAccount.packagesIsp.packagesFno.speedProfile.downloadMbps}}
                                        <v-icon style="height: 15px" color="red">arrow_drop_up</v-icon>
                                        {{serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps}}
                                    </v-layout>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="fontSize: 14px">
                                {{serviceAccount.packagesIsp.packagesFno.packageBasePrice | currency}} pm
                                <small>excl. VAT</small>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-subheader style="background: #f0f0f0">Internet Service Provider</v-subheader>
                        <v-list-tile style="fontSize: 14px">
                            <v-list-tile-avatar>
                                <v-img contain :src="serviceAccount.customerOrganisation.logo" />
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{serviceAccount.customerOrganisation.name}}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile style="fontSize: 14px">
                            <v-list-tile-action>
                                <v-icon>bar_chart</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{serviceAccount.packagesIsp.name}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    {{serviceAccount.packagesIsp.term}} | {{serviceAccount.packagesIsp.onceOffPriceVatInc | currency}} Once-Off
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="fontSize: 14px">
                                {{serviceAccount.packagesIsp.recurringPriceVatInc | currency}} pm
                                <small>incl. VAT</small>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile style="fontSize: 14px">
                            <v-list-tile-action>
                                <v-icon>event</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{formatDate(serviceAccount.fnoActivationDate)}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    Initial Activation: <span v-if="serviceAccount.initialActivation">{{formatDate(serviceAccount.initialActivation)}}</span><span v-else>{{formatDate(serviceAccount.fnoActivationDate)}}</span>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile style="fontSize: 14px" v-if="serviceAccount.authenticationType.toLowerCase() == 'pppoe'&&serviceAccount.pppoeUsername">
                            <v-list-tile-action>
                                <v-icon>router</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{serviceAccount.pppoeUsername}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    {{serviceAccount.pppoePassword}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile style="fontSize: 14px" v-if="serviceAccount.contact">
                            <v-list-tile-action>
                                <v-icon>person</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{serviceAccount.contact.name}} {{ serviceAccount.contact.surname }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 12px" v-if="serviceAccount.contact.mobileNumber">
                                   <v-icon small class="mr-2">phone</v-icon> {{formatMobileNumber(serviceAccount.contact.mobileNumber)}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-flex>
                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader two-line>
                        <v-subheader style="background: #f0f0f0"> Device</v-subheader>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>router</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 14px">
                                    {{serviceAccount.device.ponMac}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    {{serviceAccount.device.deviceMakeModel.deviceMake.name}} {{serviceAccount.device.deviceMakeModel.name}}
                                </v-list-tile-sub-title>
                                <!-- <v-list-tile-sub-title style="fontSize: 14px">
                                    {{serviceAccount.device.systemName}}
                                </v-list-tile-sub-title> -->
                            </v-list-tile-content>
                            <v-list-tile-action :key="onuKey" v-if="deviceDetail.details">
                                <v-chip color="light-green" style="height: 18px" class="white--text" :key="onuKey" v-if="deviceDetail&&deviceDetail.status&&deviceDetail.status.isOnline">Online</v-chip>
                                <v-chip color="red" style="height: 18px" class="white--text" :key="onuKey" v-else-if="deviceDetail&&deviceDetail.status&&!deviceDetail.status.isOnline">Offline</v-chip>

                            </v-list-tile-action>
                            <v-list-tile-action :key="onuKey" v-else-if="deviceDetail.status">
                                <v-chip :key="onuKey" color="light-green" style="height: 18px" class="white--text" v-if="deviceDetail&&deviceDetail.status&&deviceDetail.status.isOnline">Online</v-chip>
                                <v-chip :key="onuKey" color="red" style="height: 18px" class="white--text" v-else-if="deviceDetail&&deviceDetail.status&&!deviceDetail.status.isOnline">Offline</v-chip>

                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                    <v-list subheader two-line>

                        <v-subheader style="background: #f0f0f0"> Bridge</v-subheader>

                        <v-list-tile v-if="serviceAccount.device&&serviceAccount.device.isU2000&&serviceAccount.deviceBridge">
                            <v-list-tile-action>
                                <v-chip style="height: 18px" class="white--text" color="light-green" v-if="serviceAccount.deviceBridge.isActive">Active</v-chip>
                                <v-chip style="height: 18px" class="white--text" color="red" v-else>Inactive</v-chip>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 12px" v-if="serviceAccount.deviceBridge.servicePortId">
                                    {{serviceAccount.deviceBridge.servicePortId}}
                                </v-list-tile-title>
                                <v-list-tile-title style="fontSize: 12px" v-else>
                                    {{serviceAccount.circuitNumber}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 12px">
                                    Outer vlan: {{serviceAccount.deviceBridge.vlanXlate}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 12px" v-if="serviceAccount.deviceBridge.vlan">
                                    Inner vlan: {{serviceAccount.deviceBridge.vlan}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="font-size: 12px" v-if="serviceAccount.deviceBridge.gemportId">Gemport: {{serviceAccount.deviceBridge.gemportId}}</v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 12px">
                                    Last Updated: {{formatDateTime(serviceAccount.deviceBridge.updatedAt)}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="fontSize: 12px">
                                <v-layout justify-center>
                                    <v-icon small style="height: 15px" color="light-green">arrow_drop_down</v-icon>
                                    {{serviceAccount.deviceBridge.downstreamRate}}
                                    <v-icon small style="height: 15px" color="red">arrow_drop_up</v-icon>
                                    {{serviceAccount.deviceBridge.upstreamRate}}
                                </v-layout>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile v-else-if="serviceAccount.device&&serviceAccount.device&&serviceAccount.device.deviceMakeModel.deviceMake.name.toLowerCase()=='zhone'&&serviceAccount.deviceBridge">
                            <!-- <v-list-tile-action>
                                
                            </v-list-tile-action> -->
                            <v-list-tile-content>
                                <v-list-tile-sub-title style="fontSize: 14px" v-if="serviceAccount.deviceBridge.vlan">
                                    Outer vlan: {{serviceAccount.deviceBridge.vlan}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 14px" v-if="serviceAccount.deviceBridge.vlanXlate">
                                    Inner vlan: {{serviceAccount.deviceBridge.vlanXlate}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 14px" v-if="serviceAccount.deviceBridge.tpType">
                                    TP Type: {{tpTypeArray.find(x=>x.id == serviceAccount.deviceBridge.tpType).name}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 14px" v-if="serviceAccount.deviceBridge.rgMode">
                                    RG Mode: {{rgModeArray.find(x=>x.id == serviceAccount.deviceBridge.rgMode).name}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="font-size: 14px" v-if="serviceAccount.deviceBridge.gemportId">Port: {{serviceAccount.deviceBridge.tpIndex}}</v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 12px">
                                    Last Updated: {{formatDateTime(serviceAccount.deviceBridge.updatedAt)}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="fontSize: 12px">
                                <v-layout justify-center>
                                    <v-icon small style="height: 15px" color="light-green">arrow_drop_down</v-icon>
                                    {{serviceAccount.deviceBridge.downstreamRate}}
                                    <v-icon small style="height: 15px" color="red">arrow_drop_up</v-icon>
                                    {{serviceAccount.deviceBridge.upstreamRate}}
                                </v-layout>
                                <v-chip style="height: 18px" class="white--text" color="light-green" v-if="serviceAccount.deviceBridge.isActive">Active</v-chip>
                                <v-chip style="height: 18px" class="white--text" color="red" v-else>Inactive</v-chip>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>

                </v-flex>

                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader two-line>
                        <v-subheader style="background: #f0f0f0">Change Requests <v-chip v-if="pendingRequests.length > 0">{{pendingRequests.length}}</v-chip>
                            <v-spacer></v-spacer>
                            <v-btn icon color="primary" v-if="serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&(new Date(serviceAccount.fnoDeactivationDate)>new Date()||serviceAccount.fnoDeactivationDate==null)" @click="addChangeRequestCheck()">
                                <v-icon color="white">add</v-icon>
                            </v-btn>
                        </v-subheader>
                        <v-tabs grow v-if="resolvedRequests.length>0">
                            <v-tab @click="showPendingRequests = true, showResolvedRequests = false">Pending</v-tab>
                            <v-tab @click="showPendingRequests = false, showResolvedRequests = true">Resolved</v-tab>
                        </v-tabs>
                        <v-list v-if="showPendingRequests" three-line>
                            <v-list-tile v-for="pending in pendingRequests" :key="pending.id">
                                <v-list-tile-content>
                                    <v-list-tile-title style="fontSize: 14px">
                                        {{pending.requestType}}<span style="font-size: 12px" v-if="pending.migrationLocation">: {{pending.migrationLocation.locationDescription}}</span>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title style="fontSize: 12px">
                                        <h4 class="grey--text font-weight-light">
                                            <b>Submitted:</b> {{ formatDate(pending.createdAt) }}
                                        </h4>
                                        <h4 class="grey--text font-weight-light">
                                            <b>Requested Date:</b> {{ formatDate(pending.requestedChangeDate) }}
                                        </h4>
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title style="fontSize: 12px" v-if="(pending.requestType.includes('Upgrade')||pending.requestType.includes('Downgrade'))&&pending.fromSpeedProfile&&pending.toSpeedProfile">

                                        From:
                                        <v-icon small color="light-green">arrow_drop_down</v-icon>
                                        {{pending.fromSpeedProfile.downloadMbps}}
                                        <v-icon small color="red">arrow_drop_up</v-icon>
                                        {{pending.fromSpeedProfile.uploadMbps}}
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title style="font-size: 12px" v-if="(pending.requestType.includes('Upgrade')||pending.requestType.includes('Downgrade'))&&pending.fromSpeedProfile&&pending.toSpeedProfile">
                                        To:
                                        <v-icon small color="light-green">arrow_drop_down</v-icon>
                                        {{pending.toSpeedProfile.downloadMbps}}
                                        <v-icon small color="red">arrow_drop_up</v-icon>
                                        {{pending.toSpeedProfile.uploadMbps}}
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <!-- <v-list-tile-action>
                                    <v-layout justify-center>
                                        <v-progress-circular size="20" v-if="acceptingRequestChange" indeterminate color="primary"></v-progress-circular>
                                        <v-btn icon v-else-if="!denyingRequestChange" class="mx-1">
                                            <v-icon small color="light-green" @click="pending.requestType != 'Reactivation'? acceptRequestChange(pending):acceptReactivation(pending)">done</v-icon>
                                        </v-btn>

                                        <v-progress-circular v-if="denyingRequestChange" size="20" indeterminate color="primary"></v-progress-circular>
                                        <v-btn class="mx-1" icon v-else-if="!acceptingRequestChange">
                                            <v-icon small color="red" @click="denyRequestItem(pending)">clear</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </v-list-tile-action> -->
                                <v-lits-tile-action>
                                    <v-btn @click="openCancelRequestConfirmation(pending)" class="mx-1" icon><v-icon small color="red">clear</v-icon></v-btn>
                                </v-lits-tile-action>
                            </v-list-tile>
                            <v-list-tile v-if="pendingRequests.length==0">
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    No Pending Requests
                                </v-list-tile-sub-title>
                            </v-list-tile>
                        </v-list>
                        <v-list v-else-if="showResolvedRequests" three-line>
                            <v-list-tile v-for="resolved in resolvedRequests" :key="resolved.id">
                                <v-list-tile-action>
                                    <v-chip style="height: 18px" class="white--text" dense v-if="resolved.status=='Resolved'" color="light-green">{{resolved.status}}</v-chip>
                                    <v-chip style="height: 18px" class="white--text" dense v-else color="red">{{resolved.status}}</v-chip>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title style="fontSize: 14px">
                                        {{resolved.requestType}}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title style="fontSize: 12px" v-if="(resolved.requestType.includes('Upgrade')||resolved.requestType.includes('Downgrade'))&&resolved.fromSpeedProfile&&resolved.toSpeedProfile">

                                        From:
                                        <v-icon small color="light-green">arrow_drop_down</v-icon>
                                        {{resolved.fromSpeedProfile.downloadMbps}}
                                        <v-icon small color="red">arrow_drop_up</v-icon>
                                        {{resolved.fromSpeedProfile.uploadMbps}}
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title style="font-size: 12px" v-if="(resolved.requestType.includes('Upgrade')||resolved.requestType.includes('Downgrade'))&&resolved.fromSpeedProfile&&resolved.toSpeedProfile">
                                        To:
                                        <v-icon small color="light-green">arrow_drop_down</v-icon>
                                        {{resolved.toSpeedProfile.downloadMbps}}
                                        <v-icon small color="red">arrow_drop_up</v-icon>
                                        {{resolved.toSpeedProfile.uploadMbps}}
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title style="font-size: 12px">
                                        {{formatDate(resolved.updatedAt)}}
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    {{resolved.fnoContactName}}
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile v-if="resolvedRequests.length==0">
                                <v-list-tile-sub-title style="fontSize: 14px">
                                    No Resolved Requests
                                </v-list-tile-sub-title>
                            </v-list-tile>
                        </v-list>
                    </v-list>
                </v-flex>
                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader two-line>
                        <v-subheader style="background: #f0f0f0">Tickets <v-chip v-if="pendingTickets.length > 0">{{pendingTickets.length}}</v-chip>
                            <v-spacer></v-spacer>
                            <!-- <v-btn icon color="primary" @click="addTicket()">
                                <v-icon color="white">add</v-icon>
                            </v-btn> -->
                            <v-btn icon color="primary" @click="getTickets()">
                                <v-icon color="white">refresh</v-icon>
                            </v-btn>
                        </v-subheader>
                        <v-tabs grow v-if="resolvedTickets.length>0">
                            <v-tab @click="showPendingTickets = true, showResolvedTickets = false">Pending</v-tab>
                            <v-tab @click="showPendingTickets = false, showResolvedTickets = true">Resolved</v-tab>
                        </v-tabs>
                        <v-list v-if="showPendingTickets">
                            <v-list-tile v-for="pending in pendingTickets" :key="pending.id" @click="routeToTicketSummary(pending.id)">
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px" v-if="pending.name">
                                        {{pending.name}}
                                    </v-list-tile-title>
                                    <v-list-tile-title style="font-size: 14px" v-else>
                                        <span v-if="pending.ticketCategory">{{pending.ticketCategory.name}} </span>
                                        <span v-else-if="pending.ticketCategoryItem.ticketCategory">{{pending.ticketCategoryItem.ticketCategory.name}}</span>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title style="font-size: 14px">{{pending.ticketCategoryItem.name}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-chip style="height: 18px" :class="`${pending.currentStatus.replace(/\s/g,'').toLowerCase()} white--text`">{{pending.currentStatus}}</v-chip>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile v-if="pendingTickets.length == 0">
                                <v-list-tile-sub-title style="font-size: 14px">
                                    No Pending Tickets.
                                </v-list-tile-sub-title>
                            </v-list-tile>
                        </v-list>
                        <v-list v-else-if="showResolvedTickets">
                            <v-list-tile v-for="resolved in resolvedTickets" :key="resolved.id" @click="routeToTicketSummary(resolved.id)">
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px" v-if="resolved.name">
                                        {{resolved.name}}
                                    </v-list-tile-title>
                                    <v-list-tile-title style="font-size: 14px" v-else>
                                        <span v-if="resolved.ticketCategory">{{resolved.ticketCategory.name}} </span>
                                        <span v-else-if="resolved.ticketCategoryItem.ticketCategory">{{resolved.ticketCategoryItem.ticketCategory.name}}</span>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title style="font-size: 14px">{{resolved.ticketCategoryItem.name}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-chip style="height: 18px" :class="`${resolved.currentStatus.replace(/\s/g,'').toLowerCase()} white--text`">{{resolved.currentStatus}}</v-chip>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </v-list>
                </v-flex>
            </v-layout>

        </v-flex>

        <v-flex xs12 sm4 class="text-xs-left">
            <v-list subheader>
                <v-subheader style="background: #f0f0f0">
                    <v-icon class="mx-1">timeline</v-icon>Timeline
                </v-subheader>
                <div style="overflow-y: auto; max-height: 80vh; padding: 5px">
                    <v-timeline dense>
                        <v-timeline-item fill-dot v-for="(item, index) in allServiceAccountHistory" :icon="getIcon(item)" :color="item.colour?item.colour:'grey'" :key="index">
                            <v-card v-if="item.logType == 'Account'">
                                <v-card-text style="font-size: 12px">
                                    <span v-html="item.circuitNumber"></span>
                                    <br />
                                    <v-layout align-center justify-start style="fontSize: 12px">
                                        <v-icon style="height: 12px" color="light-green">arrow_drop_down</v-icon>
                                        {{item.packagesIsp.packagesFno.speedProfile.downloadMbps}}
                                        <v-icon style="height: 12px" color="red">arrow_drop_up</v-icon>
                                        {{item.packagesIsp.packagesFno.speedProfile.uploadMbps}}
                                    </v-layout>
                                    <v-chip color="red" style="height: 16px; font-size:12px" class="white--text" v-if="item.isSuspended">Account Suspended</v-chip>
                                    <br v-if="item.isSuspended" />
                                    <span style="color: grey; font-size: 10px">{{ item.fnoActivationDate }} <span v-if="item.fnoDeactivationDate">- {{item.fnoDeactivationDate}}</span></span>
                                </v-card-text>
                            </v-card>
                            <v-card v-else-if="item.logType == 'Change'">
                                <v-card-text style="font-size: 12px">
                                    <span>{{item.requestType}} Request</span>
                                    <br />
                                    <span style="font-size: 11px" v-if="item.migrationLocation">Move services from <b>{{item.location.locationDescription}}</b> to <b>{{item.migrationLocation.locationDescription}}</b></span>
                                    <br v-if="item.migrationLocation" />
                                    <span style="font-size: 11px" v-if="item.requestedBy"><b>{{item.requestedBy.name +' ' +item.requestedBy.surname}}</b> requested the change for {{formatDate(item.requestedChangeDate)}}</span>
                                    <br v-if="item.requestedBy" />
                                    <span style="font-size: 11px" v-if="item.approvedBy"><b>{{item.approvedBy.name +' ' +item.approvedBy.surname}}</b> {{item.status == 'Resolved'?'approved':'rejected'}} the change on {{formatDate(item.dateResolved)}}</span>
                                    <span style="font-size: 11px" v-else-if="item.status=='Resolved'||item.status=='Denied'||item.status=='Canceled'">Change {{item.status == 'Resolved'?'approved':'rejected'}} on {{item.dateResolved?formatDate(item.dateResolved):formatDateTime(item.updatedAt)}}</span>
                                    <br v-if="item.status == 'Denied'&&item.comment"/>
                                    <span style="font-size: 11px" v-if="item.status == 'Denied'&&item.comment">Reason: <i>{{item.comment}}</i></span>
                                    <br  v-if="item.status=='Resolved'||item.status=='Denied'||item.status=='Canceled'"/>
                                    <span style="color: grey; font-size: 10px">{{ formatDateTime(item.createdAt) }}</span>
                                </v-card-text>
                            </v-card>
                        </v-timeline-item>
                    </v-timeline>
                </div>
            </v-list>

        </v-flex>
    </v-layout>

 

    <v-dialog v-model="reactivationModal" persistent width="750px">
        <v-card flat color="white">
            <v-toolbar flat color="primary">
                <h3 class="title white--text">Reactivation Request</h3>
                <v-spacer></v-spacer>
                <v-btn flat color="white" @click="(reactivationModal = false), (changeRequestItem = {})">X</v-btn>
            </v-toolbar>
            <v-card-text pa-2>
                <v-container grid-list-xs>
                    <v-layout wrap>
                        <v-flex py-3 xs12 sm6 md6 v-if="changeRequestItem.requestType&&changeRequestItem.requestType!==null">
                            <h3 class="grey--text">Requested Change Date:</h3>
                        </v-flex>
                        <v-flex xs12 sm6 md6 v-if="changeRequestItem.requestType">
                            <v-menu :close-on-content-click="false">
                                <v-text-field :value="changeRequestItem.requestedChangeDate" slot="activator" label="Change Date" prepend-icon="date_range" readonly required></v-text-field>
                                <v-date-picker :min="today" v-model="changeRequestItem.requestedChangeDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12>
                            <h3>Provisioning Template:</h3>
                            <v-radio-group v-model="changeRequestItem.organisationBridgeTemplateId" column mandatory>
                                <v-radio v-for="template in bridgeTemplates" :key="template.id" :label="`Type: ${template.connectionType} | Inner Vlan: ${template.innerVlan} | Outer Vlan: ${template.outerVlan}`" :value="template.id"></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex class="text-xs-center">
                            <v-btn color="primary" round class="white--text" v-if="changeRequestItem.requestedChangeDate&&changeRequestItem.organisationBridgeTemplateId" @click="logServiceAccountChange(changeRequestItem)">Submit</v-btn>
                            <v-btn v-else round disabled>Submit</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="changeRequestModal" persistent width="750px">
        <v-card flat color="white">
            <v-toolbar flat color="primary">
                <h3 class="title white--text">Log Change Request</h3>
                <v-spacer></v-spacer>
                <v-btn flat color="white" @click="(changeRequestModal = false), (changeRequestItem = {})">X</v-btn>
            </v-toolbar>
            <v-card-text pa-2>
                <v-container grid-list-xs>
                    <v-layout wrap>
                        <v-flex sm12 md12>
                            <v-autocomplete ref="requestType" v-on:blur="$refs['requestType'].blur()" clearable hide-no-data flat color="primary" :items="populateRequestTypes" v-model="changeRequestItem.requestType" label="Change Request Type"></v-autocomplete>
                        </v-flex>
                        <v-flex v-if="changeRequestItem.requestType=='PPPoE Details Update'">
                            <v-text-field v-model="changeRequestItem.pppoeUsername" label="PPPoE Username"></v-text-field>
                        </v-flex>
                        <v-flex v-if="changeRequestItem.requestType=='PPPoE Details Update'">
                            <v-text-field v-model="changeRequestItem.pppoePassword" label="PPPoE Password"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12 v-if="
                  changeRequestItem.requestType == 'Upgrade' ||
                  changeRequestItem.requestType == 'Downgrade'
                ">
                            <v-text-field flat color="primary" v-model="serviceAccount.packagesIsp.name" label="From" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12 v-if="
                  changeRequestItem.requestType == 'Upgrade' ||
                  changeRequestItem.requestType == 'Downgrade'
                ">
                            <v-autocomplete ref="selectablePackages" v-on:blur="$refs['selectablePackages'].blur()" :key="keyPackages" v-if="selectablePackages.length > 0" clearable hide-no-data flat color="primary" return-object :items="selectablePackages" v-model="changeRequestItem.toPackage" item-value="id" label="*To">
                                <template v-slot:selection="data">{{
                    data.item.name
                  }}</template>
                                <template v-slot:item="data">
                                    <template>
                                        <v-list-tile-content>
                                            <v-list-tile-title class="grey--text font-weight-bold">{{ data.item.name }}
                                                <span v-if="data.item.packagesFno.isGlobal">(Globally Available)</span></v-list-tile-title>
                                            <v-list-tile-sub-title>
                                                <v-layout align-center class="grey--text font-weight-light">
                                                    <v-icon color="light-green">arrow_drop_down</v-icon>
                                                    {{
                              data.item.packagesFno.speedProfile.downloadMbps
                            }}
                                                    <v-icon color="red">arrow_drop_up</v-icon>
                                                    {{ data.item.packagesFno.speedProfile.uploadMbps }}
                                                </v-layout>
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                            <span class="grey--text" v-else-if="changeRequestItem.requestType == 'Upgrade'">No Upgradeable Packages available.</span>
                            <span class="grey--text" v-else-if="changeRequestItem.requestType == 'Downgrade'">No Downgradeable Packages available.</span>
                        </v-flex>
                        <v-flex py-3 xs12 sm6 md6 v-if="changeRequestItem.requestType&&changeRequestItem.requestType!==null">
                            <h3 class="grey--text">Requested Change Date:</h3>
                        </v-flex>
                        <v-flex xs12 sm6 md6 v-if="changeRequestItem.requestType">
                            <v-menu :close-on-content-click="false">
                                <v-text-field :value="changeRequestItem.requestedChangeDate" slot="activator" label="Change Date" prepend-icon="date_range" readonly required></v-text-field>
                                <v-date-picker :min="changeRequestItem.requestType === 'Termination' ? minTerminationDate() : today" v-model="changeRequestItem.requestedChangeDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex sm8 md8 v-if="
                  changeRequestItem.requestType == 'Migration' &&
                  changeRequestItem.requestedChangeDate
                ">
                            <v-autocomplete ref="filterNetwork" v-on:blur="$refs['filterNetwork'].blur()" v-model="filterNetwork" :items="networks" clearable item-text="name" item-value="id" label="Migration Location Network"></v-autocomplete>
                        </v-flex>
                        <v-flex sm4 md4 v-if="
                  changeRequestItem.requestType == 'Migration' &&
                  changeRequestItem.requestedChangeDate &&
                  filterNetwork
                ">
                            <v-btn flat color="primary" @click="attachLocationModal = true">
                                <v-icon>add_circle_outline</v-icon>Attach Location
                            </v-btn>
                        </v-flex>
                        <v-flex sm12 md12 v-if="
                  changeRequestItem.requestType == 'Migration' &&
                  filterNetwork &&
                  changeRequestItem.migrationLocation
                ">
                            <v-text-field label="Migration Location" v-model="
                    changeRequestItem.migrationLocation.locationDescription
                  " disabled></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn v-if="validateMigration() === true" color="primary" round class="white--text" @click="logServiceAccountChange(changeRequestItem)">Submit</v-btn>
                    <v-btn v-else disabled color="primary" round class="white--text">Submit</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="attachLocationModal" max-width="1200px">
        <v-card>
            <v-toolbar flat color="primary">
                <h3 class="headline white--text">Attach Location</h3>
                <v-spacer></v-spacer>
                <v-btn flat color="white" @click="attachLocationModal = false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout>
                    <v-spacer></v-spacer>
                    <v-flex xs6 mx-2>
                        <v-text-field label="Search" v-model="search" clearable append-icon="search" v-on:keyup.enter="
                  $router.push({
                    name: $route.name,
                    query: {
                      offset: $route.query.offset,
                      records: $route.query.records,
                      search: search,
                    },
                  })
                "></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout justify-center>
                    <v-data-table :items="filteredLocations" :headers="locationHeaders" :rows-per-page-items="[10, 20, 50, 100, 250]" :pagination.sync="pagination" hide-actions>
                        <template v-slot:items="props">
                            <td class="text-xs-center">
                                <v-icon @click="attachLocation(props.item)" color="primary">add_circle_outline</v-icon>
                            </td>
                            <td class="text-xs-center">{{ props.item.unitNo }}</td>
                            <td class="text-xs-center">{{ props.item.erfNo }}</td>
                            <td class="text-xs-center">{{ props.item.otherNo }}</td>
                            <td class="text-xs-center">
                                {{ props.item.complexStreetName }}
                            </td>
                            <td class="text-xs-center">{{ props.item.subComplexName }}</td>
                            <td class="text-xs-center">
                                {{ props.item.locationNetwork.name }}
                            </td>
                        </template>
                    </v-data-table>
                </v-layout>
                <v-layout justify-center>
                    <div class="text-xs-center pt-2 white" :key="$route.query.offset">
                        <v-pagination v-model="page" :length="
                  Math.ceil(pagination.totalItems / pagination.rowsPerPage)
                " :total-visible="7">
                        </v-pagination>
                    </div>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <!-- Add ticket Modal -->
    <v-dialog v-model="addTicketModal" persistent max-width="1000px">
        <v-card>
            <v-toolbar flat color="primary">
                <h3 class="title white--text">
                    ADD TICKET: {{ ticketItem.dueDate }}
                </h3>
                <v-spacer></v-spacer>

                <v-btn v-if="
              ticketItem.ticketCategoryId &&
              ticketItem.ticketCategoryItemId &&
              ticketItem.currentStatus &&
              ticketItem.importance &&
              ticketItem.dueDate
            " flat color="white" class="white--text" @click="createNewTicket()">Save</v-btn>
                <v-btn v-else disabled flat>Save</v-btn>
                <v-btn flat color="white" class="white--text" @click="(addTicketModal = false), (ticketItem = {})">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center align-center>
                    <v-flex>
                        <v-checkbox label="Full Day Event" v-model="dateTimeSelect"></v-checkbox>
                    </v-flex>
                    <v-flex>
                        <VueCtkDateTimePicker :minDate="today" label="Select a Date" autoClose format="YYYY-MM-DD" formatted="ll" only-date v-model="ticketItem.dueDate" />
                    </v-flex>
                    <v-flex>
                        <VueCtkDateTimePicker v-if="!dateTimeSelect" format="HH:mm" formatted="HH:mm" minuteInterval="5" label="Select Time" only-time v-model="ticketItem.dueTime" />
                    </v-flex>

                    <v-flex xs3 mx-2>
                        <v-autocomplete v-model="ticketItem.assignedToId" :items="filteredUsers" chips clearable item-text="name" item-value="id" label="Assign Ticket to a User">
                            <template v-slot:selection="{ attr, on, item, selected }">
                                <v-chip v-bind="attr" :input-value="selected" color="blue-grey" class="white--text" v-on="on">
                                    <v-icon left>person</v-icon>
                                    <span>{{ item.name }} {{ item.surname }}</span>
                                </v-chip>
                            </template>
                            <template v-slot:item="{ item }">
                                <v-avatar size="35px" color="primary" class="title font-weight-light white--text" v-if="item !== 'undefined'">{{ item.name.charAt(0)
                    }}{{ item.surname.charAt(0) }}</v-avatar>
                                <v-list-item-content>
                                    <v-list-item-title class="grey--text ml-3">{{ item.name }} {{ item.surname }}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout justify-center align-center>
                    <v-flex xs3 mx-2>
                        <v-autocomplete :items="ticketCategories" label="Select a Ticket Category" item-text="name" item-value="id" v-model="ticketItem.ticketCategoryId"></v-autocomplete>
                    </v-flex>
                    <v-flex xs3 mx-2>
                        <v-autocomplete v-if="ticketItem.ticketCategoryId" :items="filteredCategoryItems" label="Select a Subcategory" item-text="name" item-value="id" v-model="ticketItem.ticketCategoryItemId"></v-autocomplete>
                        <v-autocomplete v-else disabled :items="ticketCategories" label="Select a Subcategory" item-text="name" item-value="id"></v-autocomplete>
                    </v-flex>
                    <v-flex xs3 mx-2>
                        <v-select :items="statuses" label="Status" v-model="ticketItem.currentStatus"></v-select>
                    </v-flex>

                    <v-flex xs3 mx-2>
                        <v-select :items="importanceOptions" label="Importance" v-model="ticketItem.importance"></v-select>
                    </v-flex>
                </v-layout>
                <v-layout justify-center align-center>
                    <v-textarea label="Description" outline auto-grow v-model="ticketItem.description"></v-textarea>
                </v-layout>
                <v-layout justify-center v-if="ticketAssignedLog.length > 0">
                    <v-flex xs12>
                        <h3 class="grey--text">Assignment Log:</h3>
                    </v-flex>
                    <v-flex xs12 v-for="assigned in ticketAssignedLog" :key="assigned">
                        <v-layout justify-left align-center class="text-xs-left">
                            <v-flex xs4>
                                <h3 class="grey--text">
                                    {{ assigned.assignedBy.name }}
                                    {{ assigned.assignedBy.surname }}
                                </h3>
                            </v-flex>
                            <v-flex xs4>
                                <h3 class="grey--text">
                                    {{ assigned.assignedTo.name }}
                                    {{ assigned.assignedTo.surname }}
                                </h3>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>

                <v-layout justify-center align-center>
                    <v-flex xs3>
                        <h3 class="grey--text">Comments:</h3>
                    </v-flex>
                    <v-flex xs3>
                        <v-icon color="primary" @click="addCommentBox = true">add_circle_outline</v-icon>
                    </v-flex>
                </v-layout>
                <v-flex xs12 v-if="ticketCommentLog.length === 0 && !addCommentBox">
                    <h3 class="grey--text font-weight-light">No Comments</h3>
                </v-flex>
                <v-flex xs12 v-if="addCommentBox">
                    <v-textarea label="Comment" outline auto-grow v-model="comment"></v-textarea>
                    <v-btn round color="primary" class="white--text" @click="addComment(comment)">Comment</v-btn>
                </v-flex>
                <v-layout>
                    <v-card flat style="overflow-y: auto; max-height: 1000px">
                        <v-container style="text-align: left">
                            <v-layout wrap>
                                <v-flex xs12 v-for="comment in ticketCommentLog" :key="comment.createdAt">
                                    <v-layout justify-left align-center>
                                        <v-flex xs2>
                                            <span class="grey--text font-weight-light">{{
                          formatDateTime(comment.createdAt)
                        }}</span>
                                        </v-flex>
                                        <v-flex xs2>
                                            <span class="grey--text font-weight-light">{{ comment.commentedBy.name }}
                                                {{ comment.commentedBy.surname }}</span>
                                        </v-flex>
                                        <v-flex xs8>
                                            <span class="grey--text font-weight-light">
                                                {{ comment.comment }}
                                            </span>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="denyRequestModal" max-width="750px">
        <v-card>
            <v-toolbar flat class="primary">
                <h2 class="headline white--text">REASON FOR DENYING REQUEST:</h2>
            </v-toolbar>
            <v-layout justify-center>
                <v-flex xs10>
                    <v-textarea v-model="denyReason" label="Please provide a reason"></v-textarea>
                </v-flex>
            </v-layout>
            <v-card-actions class="justify-center layout px-0">
                <v-btn color="primary" round @click="(denyRequestModal = false), (denyReason = '')">Cancel</v-btn>
                <v-btn v-if="denyReason !== ''" color="primary" round @click="denyRequestChange(denyItem)">Submit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Wifi Dialog -->

    <v-dialog v-model="addWifiProfileItem" max-width="750px" persistent>
        <v-card flat color="white">
            <v-toolbar flat class="primary">
                <h1 class="headline white--text">{{ wifiItem.type }} WIFI PROFILE</h1>
            </v-toolbar>
            <v-card-text>
                <v-layout>
                    <v-flex xs6 px-1>
                        <v-text-field v-model="wifiItem.ssid" label="SSID"></v-text-field>
                    </v-flex>
                    <v-flex xs6 px-1>
                        <v-text-field v-model="wifiItem.password" label="Password"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs6 px-1>
                        <v-select v-model="wifiItem.encryption" label="Encryption Type" :items="encryptionTypes"></v-select>
                    </v-flex>
                    <v-flex xs6 px-1>
                        <v-select v-model="wifiItem.frequencyBand" label="Frequency Band" :items="availableFrequency"></v-select>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex xs4 px-4>
                        <v-text-field v-model="wifiItem.channel" label="Channel" type="number"></v-text-field>
                    </v-flex>
                    <v-flex xs3 ml-1 px-1>
                        <v-switch v-model="wifiItem.enable" label="Enabled"></v-switch>
                    </v-flex>
                    <v-flex xs3 px-1>
                        <v-switch v-model="wifiItem.hidden" label="Hidden"></v-switch>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn class="primary white--text" round @click="(addWifiProfileItem = false), (wifiItem = {})">Cancel</v-btn>
                    <v-btn class="primary white--text" round @click="saveWifiProfile()">Save</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="configModal" width="750px">
        <v-card color="white" flat>
            <v-toolbar color="primary" flat>
                <h3 class="title white--text">SERVICE CONFIGURATION</h3>
                <v-spacer></v-spacer>
                <v-btn color="white" flat @click="configModal=false,configurationSettings={}">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <div v-if="configurationSettings.type=='Multiple'">
                    <v-layout justify-center align-center wrap>
                        <v-flex xs10 mx-1 my-1 v-if="configurationSettings.bridgeTemplates.length>1">
                            <h4 class="grey--text">There are multiple configurations available for this device. Please choose the preferred configuration:</h4>
                        </v-flex>
                        <v-flex xs8 mx-1 mt-2 v-for="template in configurationSettings.bridgeTemplates" :key="template.id">
                            <v-card color="white" :hover="configurationSettings.selectedTemplateId!==template.id" @click="configurationSettings.selectedTemplateId=template.id, configurationSettings.connectionType=template.connectionType">
                                <v-toolbar flat :color="configurationSettings.selectedTemplateId==template.id?'light-green':'primary'">
                                    <h3 class="title white--text" v-if="template.type=='OneDevice'">One Device</h3>
                                    <h3 class="title white--text" v-else>Two Device</h3>
                                    <v-spacer></v-spacer>
                                    <v-icon large v-if="configurationSettings.selectedTemplateId==template.id" color="white">check_circle</v-icon>
                                </v-toolbar>
                                <v-card-text>
                                    <v-layout justify-left align-center mx-1 wrap class="text-xs-left">

                                        <v-flex xs4 mx-1>
                                            <h3 class="grey--text">Connection Type: </h3>
                                        </v-flex>
                                        <v-flex xs4 mx-1>
                                            <h3 class="grey--text font-weight-light">{{template.connectionType}}</h3>
                                        </v-flex>
                                        <v-flex xs4 mx-1 v-if="template.innerVlan!=0">
                                            <h3 class="grey--text">Inner VLAN: </h3>
                                        </v-flex>
                                        <v-flex xs4 mx-1 v-if="template.innerVlan!=0">
                                            <h3 class="grey--text font-weight-light">{{template.innerVlan}}</h3>
                                        </v-flex>
                                        <v-flex xs4 mx-1 v-if="template.outerVlan!=0">
                                            <h3 class="grey--text">Outer VLAN: </h3>
                                        </v-flex>
                                        <v-flex xs4 mx-1 v-if="template.outerVlan!=0">
                                            <h3 class="grey--text font-weight-light">{{template.outerVlan}}</h3>
                                        </v-flex>
                                        <v-flex xs4 mx-1 v-if="template.type=='TwoDevice'">
                                            <h3 class="red--text">Terms: </h3>
                                        </v-flex>
                                        <v-flex xs6 mx-1 v-if="template.type=='TwoDevice'">
                                            <h3 class="red--text font-weight-light">Second device is NOT provided by the network operator and will need to either be supplied by the ISP or the end customer.</h3>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>

                </div>
                <div v-if="configurationSettings.connectionType&&configurationSettings.connectionType.toLowerCase()=='pppoe'">
                    <v-layout align-center justify-center wrap my-1>
                        <v-flex xs10 mx-1 mt-2>
                            <h3 class="title grey--text">PPPoE Configuration</h3>
                        </v-flex>
                        <v-flex xs4 mx-1>
                            <v-text-field label="PPPoE Username" v-model="configurationSettings.pppoeUsername"></v-text-field>
                        </v-flex>
                        <v-flex xs4 mx-1>
                            <v-text-field label="PPPoE Password" v-model="configurationSettings.pppoePassword"></v-text-field>
                        </v-flex>

                    </v-layout>
                </div>

            </v-card-text>
            <v-card-actions>
                <v-layout justify-center align-center>
                    <v-btn round color="primary" class="white--text" v-if="configurationSettings.selectedTemplateId&&configurationSettings.connectionType&&configurationSettings.connectionType.toLowerCase()!='pppoe'" @click="reactivateZhoneServices(serviceAccount)">Submit</v-btn>
                    <v-btn round color="primary" class="white--text" v-else-if="configurationSettings.selectedTemplateId&&configurationSettings.connectionType&&configurationSettings.connectionType.toLowerCase()=='pppoe'&&configurationSettings.pppoeUsername&&configurationSettings.pppoePassword" @click="reactivateZhoneServices(serviceAccount)">Submit</v-btn>
                    <v-btn round color="primary" class="white--text" v-else disabled>Submit</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="suspendDialog" persistent max-width="750px">
        <v-card>
            <v-toolbar flat color="primary">
                <h3 class="title white--text">
                    SUSPEND
                </h3>
                <v-spacer></v-spacer>

                <v-btn v-if="suspendItem.type==='U2000'" flat color="white" class="white--text" @click="submitSuspend()">Submit</v-btn>
                <v-btn v-else-if="suspendItem.type==='Zhone'" flat color="white" class="white--text" @click="submitZhoneSuspend()">Submit</v-btn>
                <v-btn flat color="white" class="white--text" @click="(suspendDialog = false)">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center align-center>
                    <v-flex>
                        <v-menu>
                            <v-text-field :value="formatDate(this.suspendItem.dueDate)" slot="activator" label="Preferred Date" prepend-icon="date_range"></v-text-field>
                            <v-date-picker :min="todaySuspend" v-model="suspendItem.dueDate"></v-date-picker>
                        </v-menu>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <!-- Cancel Change Request Confirmation Modal -->
    <v-dialog v-model="cancelRequestItemConfirmation" persistent max-width='750px'>
        <v-card>
            <v-toolbar flat class="primary">
                <h3 class="title white--text">Cancel Change Request</h3>
            </v-toolbar>
            <v-card-text>
                Are you sure you would like to cancel this change request?
            </v-card-text>
            <v-card-actions class="justify-center layout px-0">
                <v-btn color="primary" class="white--text" @click="changeRequestItemToCancel=null, cancelRequestItemConfirmation=false" :disabled="loadingCancelChangeRequest">No</v-btn>
                <v-btn color="red" class="white--text" @click="cancelRequestItem()" :loading="loadingCancelChangeRequest">Yes</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import {
    VueSvgGauge
} from "vue-svg-gauge";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import configData from "../../../config/config.json";
import axios from "axios";
const CancelToken = axios.CancelToken;
let source = null
export default {
    components: {
        VueCtkDateTimePicker: VueCtkDateTimePicker,
        VueSvgGauge,
        Loading: Loading,
    },
    data() {
        return {
            suspendDialog: false,
            suspendItem: {
                dueDate: ''
            },
            populateRequestTypes: [],
            bridgeTemplates: [],
            configurationSettings: {},
            configModal: false,
            submit: true,
            online: false,
            terminatePreviousList: [],
            migrationLocationSet: false,
            previousAccountsList: [],
            pagination: {
                totalItems: 0
            },
            previousAccounts: false,
            deviceDetail: {},
            onuKey: 0,
            onuStatus: {
                initiated: false,
                isOnline: false,
                complete: true
            },
            noAcsDeviceOnLocation: false,
            noZhoneDeviceOnLocation: false,
            filterNetwork: null,
            search: "",
            page: 1,
            locationLength: 0,
            filteredLocations: [],
            networks: [],
            attachLocationModal: false,
            showDownloadError: false,
            showUploadError: false,
            loader: null,
            config: null,
            keySpeed: 0,
            acsDevice: false,
            maxDownload: 0,
            maxUpload: 0,
            uploadSpeed: 0,
            downloadSpeed: 0,
            visibleDownload: false,
            visibleUpload: false,
            dateTimeSelect: false,
            addTemplate: false,
            addCommentBox: false,
            statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
            importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
            ticketItem: {},
            ticketCategories: [],
            ticketCategoryItems: [],
            filteredCategoryItems: [],
            filteredUsers: [],
            ticketAssignedLog: [],
            ticketCommentLog: [],
            filteredTickets: {},
            ticketTemplates: [],
            addTicketModal: false,
            addWifiProfileItem: false,
            allOpenTickets: [],
            allPendingRequests: [],
            allIspPackages: [],
            allResolvedRequests: [],
            allResolvedTickets: [],
            allServiceAccountHistory: [],
            availableFrequency: [],
            changeRequestItem: {},
            changeRequestModal: false,
            denyItem: {},
            denyReason: "",
            denyRequestModal: false,
            encryptionTypes: ["WEP", "WPA", "WPA2", "WPA+WPA2"],
            errorSnackbar: false,
            internetServices: [],
            pendingRequests: [],
            pendingTickets: [],
            pendingRequestPage: 1,
            pendingTicketPage: 1,
            reactivationModal: false,
            resolvedRequests: [],
            resolvedTickets: [],
            resolvedRequestPage: 1,
            resolvedTicketPage: 1,
            selectablePackages: [],
            keyPackages: 0,
            serviceAccount: null,
            serviceAccountHistory: [],
            serviceAccountHistoryPage: 1,
            showInternet: true,
            showWifi: false,
            showVoip: false,
            showPendingRequests: true,
            showResolvedRequests: false,
            showPendingTickets: true,
            showResolvedTickets: false,
            snackbar: false,
            text: "",
            todaySuspend: new Date().toISOString().substr(0, 10),
            today: new Date().toISOString().substr(0, 10),
            top: "y",
            wifiItem: {},
            wifiServices: [],
            voipServices: [],
            setIntervalId: null,
            rgModeArray: [{
                    id: 1,
                    name: 'Routed'
                },
                {
                    id: 2,
                    name: 'BRouted'
                },
                {
                    id: 3,
                    name: 'rPPPoE'
                },
                {
                    id: 4,
                    name: 'bPPPoE'
                },
                {
                    id: 5,
                    name: 'Bridged'
                },
                {
                    id: 6,
                    name: 'Not Applicable'
                }

            ],
            tpTypeArray: [{
                    id: 1,
                    name: 'Ethernet UNI'
                },
                {
                    id: 2,
                    name: 'VCC Termination Point'
                },
                {
                    id: 3,
                    name: 'Mapper Service Profile'
                },
                {
                    id: 4,
                    name: 'IP Host Config Data'
                },
                {
                    id: 5,
                    name: 'GEM Interworking Termination Point'
                },
                {
                    id: 6,
                    name: 'Multicast GEM Interworking Termination Point'
                },
                {
                    id: 7,
                    name: 'xDSL UNI'
                },
                {
                    id: 8,
                    name: 'VDSL UNI'
                },
                {
                    id: 9,
                    name: 'Ether Flow Termination Point'
                },
                {
                    id: 10,
                    name: 'Physical Path UNI'
                },
                {
                    id: 11,
                    name: 'Physical Path RF Video UNI'
                },
                {
                    id: 12,
                    name: 'Physical Path IPTV UNI'
                },
                {
                    id: 13,
                    name: 'H248 Voice'
                },
                {
                    id: 14,
                    name: 'SIP Voice'
                },
                {
                    id: 15,
                    name: 'SIP PLAR Voice'
                },
                {
                    id: 16,
                    name: 'PWE Termination'
                },
                {
                    id: 17,
                    name: 'Virtual Ethernet'
                },
                {
                    id: 18,
                    name: 'dot11 Termination Point'
                },
                {
                    id: 19,
                    name: 'Fiber LAN Termination Point'
                },
                {
                    id: 20,
                    name: 'TR69 Termination Point'
                },
                {
                    id: 21,
                    name: 'Management Termination Point'
                },
                {
                    id: 22,
                    name: 'MGCP Voice Termination Point'
                }
            ],
            locationHeaders: [{
                    text: "Action",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "Unit No",
                    align: "center",
                    value: "unitNo",
                },
                {
                    text: "Erf No",
                    align: "center",
                    value: "erfNo",
                },
                {
                    text: "Other No",
                    align: "center",
                    value: "otherNo",
                },
                {
                    text: "Street Name",
                    align: "center",
                    value: "complexStreetName",
                },
                {
                    text: "Sub Complex",
                    align: "center",
                    value: "locationNetworkSubComplex.subcomplexName",
                },
                {
                    text: "Network",
                    align: "center",
                    value: "locationNetwork.name",
                },
            ],
            changeRequestItemToCancel: null,
            cancelRequestItemConfirmation: false,
            loadingCancelChangeRequest: false,
        };
    },
    watch: {
        "ticketItem.ticketTemplateId": {
            immediate: true,
            async handler(value) {
                if (value === null && this.ticketItem.ticketCategoryId != null) {
                    Api()
                        .get(
                            "/ticketCategoryItem/byCategory/" +
                            this.ticketItem.ticketCategoryId
                        )
                        .then((response) => {
                            for (let k = 0; k < response.length; k++) {
                                this.filteredCategoryItems = response.data[k];
                            }
                        });
                }
            },
        },
        "ticketItem.ticketCategoryId": {
            immediate: true,
            async handler(value) {
                if (value && value !== null) {
                    this.filteredCategoryItems = await this.ticketCategoryItems.filter(
                        function (el) {
                            return el.ticketCategoryId === value;
                        }
                    );
                } else {
                    this.filteredCategoryItems = this.ticketCategoryItems;
                }
            },
        },
        "ticketItem.assignedToId": {
            immediate: true,
            handler(value) {
                if (this.editTicketModal && value !== this.initialAssignedId) {
                    if (
                        this.ticketItem.id &&
                        value !== null &&
                        typeof value !== "undefined"
                    ) {
                        Api()
                            .post("/ticketAssignLog", {
                                ticketId: this.ticketItem.id,
                                assignedToId: this.ticketItem.assignedToId,
                            })
                            .then((response) => {
                                let find = this.users.find((x) => x.id === value);
                                response.data.assignedTo = find;
                                response.data.assignedBy = this.$store.state.user;
                                this.ticketAssignedLog.push(response.data);
                            });
                        Api().put("/ticket/" + this.ticketItem.id, {
                            assignedToId: this.ticketItem.assignedToId,
                        });
                    }
                }
            },
        },
        resolvedTicketPage(value) {
            this.resolvedTickets = this.allResolvedTickets.slice(value - 1, value);
        },
        pendingTicketPage(value) {
            this.pendingTickets = this.allOpenTickets.slice(value - 1, value);
        },
        resolvedRequestPage(value) {
            this.resolvedRequests = this.allResolvedRequests.slice(value - 1, value);
        },
        pendingRequestPage(value) {
            this.pendingRequests = this.allPendingRequests.slice(value - 1, value);
        },
        serviceAccountHistoryPage(value) {
            if (value == 1) {
                this.serviceAccountHistory = this.allServiceAccountHistory.slice(0, 2);
            } else {
                this.serviceAccountHistory = this.allServiceAccountHistory.slice(
                    value * 2 - 2,
                    value * 2
                );
            }
        },
        "changeRequestItem.requestType": {
            immediate: true,
            handler(value) {
                if (value == "Upgrade") {
                    this.selectablePackages = this.allIspPackages.filter((x) => {
                        return (
                            (x.locationNetworkId ===
                                this.serviceAccount.location.locationNetworkId ||
                                x.packagesFno.isGlobal) &&
                            x.packagesFno.speedProfile.downloadMbps >=
                            this.serviceAccount.packagesIsp.packagesFno.speedProfile
                            .downloadMbps ||
                            (x.packagesFno.speedProfile.uploadMbps >
                                this.serviceAccount.packagesIsp.packagesFno.speedProfile
                                .uploadMbps)
                        );
                    });
                    this.keyPackages++
                } else if (value == "Downgrade") {
                    this.selectablePackages = this.allIspPackages.filter((x) => {
                        return (
                            (x.locationNetworkId ===
                                this.serviceAccount.location.locationNetworkId ||
                                x.packagesFno.isGlobal) &&
                            x.packagesFno.speedProfile.downloadMbps <=
                            this.serviceAccount.packagesIsp.packagesFno.speedProfile
                            .downloadMbps ||
                            x.packagesFno.speedProfile.uploadMbps <=
                            this.serviceAccount.packagesIsp.packagesFno.speedProfile
                            .uploadMbps
                        );
                    });
                    this.keyPackages++
                }
            },
        },
        page(value) {
            this.pagination.page = this.page;
            if (value && value != "" && value != this.$route.query.records) {
                if (this.$route.query.search) {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            offset: (value - 1) * this.$route.query.records,
                            records: this.$route.query.records,
                            search: this.$route.query.search,
                        },
                    });
                } else {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            offset: (value - 1) * this.$route.query.records,
                            records: this.$route.query.records,
                        },
                    });
                }
            }
        },
        filterNetwork(value) {
            if (value !== null && typeof value !== "undefined") {
                Api()
                    .get("/Locations/customer/byNetwork/" + value + "/activeFilter")
                    .then((response) => {
                        this.filteredLocations = response.data.result;
                        this.locationLength = response.data.count;
                        this.pagination.totalItems = this.locationLength;
                        //this.attachLocationModal=true
                    });
            }
        },
        "$route.query.search": {
            immediate: true,
            handler(value) {
                if (this.$route.query.search && value !== "" && value != null) {
                    Api()
                        .get(
                            "/Locations/customer/byNetwork/" +
                            this.filterNetwork +
                            "/activeFilter", {
                                params: {
                                    search: value,
                                    offset: "0",
                                    records: this.$route.query.records,
                                },
                            }
                        )
                        .then((response) => {
                            this.filteredLocations = response.data.result;
                            this.locationLength = response.data.count;
                            this.pagination.totalItems = this.locationLength;
                        });
                } else if (this.$route.query.offset) {
                    Api()
                        .get(
                            "/Locations/customer/byNetwork/" +
                            this.filterNetwork +
                            "/activeFilter", {
                                params: {
                                    offset: this.$route.query.offset,
                                    records: this.$route.query.records,
                                },
                            }
                        )
                        .then((response) => {
                            this.filteredLocations = response.data.result;
                            this.locationLength = response.data.count;
                            this.pagination.totalItems = this.locationLength;
                        });
                }
            },
        },
        "$route.query.offset": {
            immediate: true,
            handler(value) {
                this.loading = true;
                if (
                    value !== "" &&
                    value != null &&
                    this.$route.query.search &&
                    this.$route.query.search != "" &&
                    this.$route.query.search !== null
                ) {
                    Api()
                        .get(
                            "/Locations/customer/byNetwork/" +
                            this.filterNetwork +
                            "/activeFilter", {
                                params: {
                                    search: this.$route.query.search,
                                    offset: this.$route.query.offset,
                                    records: this.$route.query.records,
                                },
                            }
                        )
                        .then((response) => {
                            this.filteredLocations = response.data.result;
                            this.locationLength = response.data.count;
                            this.pagination.totalItems = this.locationLength;
                        });
                } else if (value !== "" && value != null) {
                    Api()
                        .get(
                            "/Locations/customer/byNetwork/" +
                            this.filterNetwork +
                            "/activeFilter", {
                                params: {
                                    offset: this.$route.query.offset,
                                    records: this.$route.query.records,
                                },
                            }
                        )
                        .then((response) => {
                            this.filteredLocations = response.data.result;
                            this.locationLength = response.data.count;
                            this.pagination.totalItems = this.locationLength;
                        });
                }
            },
        },
        migrationLocationSet: {
            immediate: true,
            handler(value) {
                if (value === true) {
                    if (
                        this.changeRequestItem.requestType === "Migration" &&
                        this.changeRequestItem.migrationLocation
                    ) {
                        if (this.serviceAccount.device.acsDevice === true) {
                            Api()
                                .get(
                                    "/devices/acs/byLocation/" +
                                    this.changeRequestItem.migrationLocation.id
                                )
                                .then((response) => {
                                    if (response.data.length > 0) {
                                        this.noAcsDeviceOnLocation = false;

                                        Api()
                                            .get(
                                                "/serviceAccounts/customer/active/byLocation/" +
                                                this.changeRequestItem.migrationLocation.id
                                            )
                                            .then((response) => {
                                                this.previousAccountsList = response.data;
                                                this.previousAccountsList.map(
                                                    (x) => (x.terminate = true)
                                                );
                                                for (
                                                    let k = 0; k < this.previousAccountsList.length; k++
                                                ) {
                                                    this.terminate(this.previousAccountsList[k]);
                                                }

                                                if (response.data.length > 0) {
                                                    for (let k = 0; k < response.data.length; k++) {
                                                        let endDate = new Date(
                                                            response.data[k].fnoDeactivationDate
                                                        );
                                                        let requestDate = new Date(
                                                            this.changeRequestItem.requestedChangeDate
                                                        );
                                                        if (
                                                            endDate > requestDate ||
                                                            response.data[k].fnoDeactivationDate === null
                                                        ) {
                                                            this.previousAccounts = true;
                                                            return false;
                                                        } else {
                                                            this.previousAccounts = false;
                                                            return true;
                                                        }
                                                    }
                                                } else {
                                                    this.previousAccounts = false;
                                                    return true;
                                                }
                                            });
                                    } else {
                                        this.noAcsDeviceOnLocation = true;

                                        Api()
                                            .get(
                                                "/serviceAccounts/customer/active/byLocation/" +
                                                this.changeRequestItem.migrationLocation.id
                                            )
                                            .then((response) => {
                                                this.previousAccountsList = response.data;
                                                this.previousAccountsList.map(
                                                    (x) => (x.terminate = true)
                                                );
                                                for (
                                                    let k = 0; k < this.previousAccountsList.length; k++
                                                ) {
                                                    this.terminate(this.previousAccountsList[k]);
                                                }

                                                if (response.data.length > 0) {
                                                    for (let k = 0; k < response.data.length; k++) {
                                                        let endDate = new Date(
                                                            response.data[k].fnoDeactivationDate
                                                        );
                                                        let requestDate = new Date(
                                                            this.changeRequestItem.requestedChangeDate
                                                        );
                                                        if (
                                                            endDate > requestDate ||
                                                            response.data[k].fnoDeactivationDate === null
                                                        ) {
                                                            this.previousAccounts = true;
                                                            return false;
                                                        } else {
                                                            this.previousAccounts = false;
                                                            return false;
                                                        }
                                                    }
                                                } else {
                                                    this.previousAccounts = false;
                                                    return false;
                                                }
                                            });
                                    }
                                });
                        } else if (
                            this.serviceAccount.device.Handle_ID !== 0 &&
                            this.serviceAccount.device.Handle_ID !== null
                        ) {
                            Api()
                                .get(
                                    "/devices/zhone/byLocation/" +
                                    this.changeRequestItem.migrationLocation.id
                                )
                                .then((response) => {
                                    if (response.data.length > 0) {
                                        this.noZhoneDeviceOnLocation = false;

                                        Api()
                                            .get(
                                                "/serviceAccounts/customer/active/byLocation/" +
                                                this.changeRequestItem.migrationLocation.id
                                            )
                                            .then((response) => {
                                                this.previousAccountsList = response.data;
                                                this.previousAccountsList.map(
                                                    (x) => (x.terminate = true)
                                                );
                                                for (
                                                    let k = 0; k < this.previousAccountsList.length; k++
                                                ) {
                                                    this.terminate(this.previousAccountsList[k]);
                                                }

                                                if (response.data.length > 0) {
                                                    for (let k = 0; k < response.data.length; k++) {
                                                        let endDate = new Date(
                                                            response.data[k].fnoDeactivationDate
                                                        );
                                                        let requestDate = new Date(
                                                            this.changeRequestItem.requestedChangeDate
                                                        );
                                                        if (
                                                            endDate > requestDate ||
                                                            response.data[k].fnoDeactivationDate === null
                                                        ) {
                                                            this.previousAccounts = true;
                                                            return false;
                                                        } else {
                                                            this.previousAccounts = false;
                                                            return true;
                                                        }
                                                    }
                                                } else {
                                                    this.previousAccounts = false;
                                                    return true;
                                                }
                                            });
                                    } else {
                                        this.noZhoneDeviceOnLocation = true;

                                        Api()
                                            .get(
                                                "/serviceAccounts/customer/active/byLocation/" +
                                                this.changeRequestItem.migrationLocation.id
                                            )
                                            .then((response) => {
                                                this.previousAccountsList = response.data;
                                                this.previousAccountsList.map(
                                                    (x) => (x.terminate = true)
                                                );
                                                for (
                                                    let k = 0; k < this.previousAccountsList.length; k++
                                                ) {
                                                    this.terminate(this.previousAccountsList[k]);
                                                }

                                                if (response.data.length > 0) {
                                                    for (let k = 0; k < response.data.length; k++) {
                                                        let endDate = new Date(
                                                            response.data[k].fnoDeactivationDate
                                                        );
                                                        let requestDate = new Date(
                                                            this.changeRequestItem.requestedChangeDate
                                                        );
                                                        if (
                                                            endDate > requestDate ||
                                                            response.data[k].fnoDeactivationDate === null
                                                        ) {
                                                            this.previousAccounts = true;
                                                            return false;
                                                        } else {
                                                            this.previousAccounts = false;
                                                            return false;
                                                        }
                                                    }
                                                } else {
                                                    this.previousAccounts = false;
                                                    return false;
                                                }
                                            });
                                    }
                                });
                        }
                    } else {
                        return true;
                    }

                    this.migrationLocationSet = false;
                }
            },
        },
    },
    async created() {
        source = CancelToken.source();
        this.config = configData;
        await this.getServiceAccountDetails();

        this.getChangeRequests();
        this.getServiceAccountHistory();
        this.getActiveISPPackages();
        this.getTickets();
        this.fetchOrgContacts();
        this.fetchTicketCategories();
        this.fetchTicketCategoryItems();
        this.fetchTicketTemplates();
        this.fetchNetworks();
        this.getAvailableTemplates();
        this.$router.push({
            name: this.$route.name,
            query: {
                offset: "0",
                records: "10"
            }
        });

    },
    methods: {
        minTerminationDate() {
            // One calendar month's notice: earliest effective date is the
            // last day of NEXT calendar month, matching the notice period
            // ISPs already give their own customers (Afrihost, Cool Ideas,
            // RSAWEB, Webafrica all use this same convention).
            const now = new Date()
            const lastDayOfNextMonth = new Date(now.getFullYear(), now.getMonth() + 2, 0)
            const yyyy = lastDayOfNextMonth.getFullYear()
            const mm = String(lastDayOfNextMonth.getMonth() + 1).padStart(2, '0')
            const dd = String(lastDayOfNextMonth.getDate()).padStart(2, '0')
            return `${yyyy}-${mm}-${dd}`
        },
        async getAvailableTemplates() {
            Api()
                .get(
                    "/customer/organisationBridgeTemplate/byCustomerDeviceMake/" +
                    this.serviceAccount.device.deviceMakeModel.deviceMakeId + "/" + this.serviceAccount.supplierOrganisationId
                )
                .then(response => {
                    this.bridgeTemplates = response.data
                    if (this.serviceAccount.device.deviceMakeModel.oneDevicePolicy && this.serviceAccount.device.deviceMakeModel.twoDevicePolicy) {
                        this.bridgeTemplates = this.bridgeTemplates.filter((x) => x.type == "OneDevice" || x.type == "TwoDevice");
                    } else if (this.serviceAccount.device.deviceMakeModel.oneDevicePolicy && !this.serviceAccount.device.deviceMakeModel.twoDevicePolicy) {
                        this.bridgeTemplates = this.bridgeTemplates.filter((x) => x.type == "OneDevice");
                    } else if (!this.serviceAccount.device.deviceMakeModel.oneDevicePolicy && this.serviceAccount.device.deviceMakeModel.twoDevicePolicy) {
                        this.bridgeTemplates = this.bridgeTemplates.filter((x) => x.type == "TwoDevice");
                    }
                })
        },
        formatMobileNumber(number){
            let result = ''
            for(let i=0;i<number.length;i++){
                if(i<(number.length-4)){
                    result += '*'
                } else {
                    result += number[i]
                }
            }
            return result
        },
        routeToServiceAccount() {
            this.$router.push({
                path: "/ispServiceAccounts"
            });
        },
        getIcon(obj) {
            if (obj.logType == 'Account') {
                return 'miscellaneous_services'

            } else {
                switch (obj.status) {
                    case 'Resolved':
                        return 'check'
                    case 'Denied':
                        return 'close'
                    case 'Canceled':
                        return 'close'
                    case 'Pending':
                        return 'pending'
                }
            }

        },
        getOnuStatus(handleId) {
            this.onuStatus.initiated = true
            if (this.onuStatus.complete) {
                this.onuStatus.complete = false
                Api().get('/zhone/onuStatus/isp/' + this.serviceAccount.supplierOrganisationId + '/' + handleId, {
                        cancelToken: source.token
                    })
                    .then(response => {
                        if (response.data.code == 200) {
                            this.onuStatus = {
                                initiated: true,
                                isOnline: ((response.data.data.onuStatusWord == '00000000000000000000001') || response.data.data.onuStatusWord == '01000000000000000000001') ? true : false,
                                lastUpdated: new Date(),
                                complete: true
                            }
                        } else {
                            this.onuStatus = {
                                initiated: true,
                                isOnline: false,
                                lastUpdated: new Date(),
                                complete: true
                            }
                        }
                    })
            }

        },
        deviceStatus(ponMac) {
            Api()
                .get("/acs/deviceDetail/" + ponMac)
                .then((response) => {
                    let online = response.data.message.uptime > 0 ? true : false;
                    if (online === true) {
                        this.online = true;
                    }
                });
        },
        addChangeRequestCheck() {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                this.changeRequestModal = true
                this.noZhoneDeviceOnLocation = false
                this.noAcsDeviceOnLocation = false
                this.previousAccounts = false
            }
        },

        async terminate(serviceAccount) {
            if (serviceAccount.terminate === true) {
                this.submit = true
                let obj = {
                    status: "Pending",
                    serviceAccountId: serviceAccount.id,
                    serviceAccountIdentifier: serviceAccount.serviceAccountIdentifier,
                    locationId: serviceAccount.locationId,
                    migrationLocationId: serviceAccount.migrationLocationId || null,
                    packagesIspId: serviceAccount.packagesIspId,
                    locationDescription: serviceAccount.location.locationDescription,
                    customerOrganisationId: serviceAccount.packagesIsp
                        .customerOrganisationId,
                    organisationId: serviceAccount.organisationId,
                    ispName: serviceAccount.customerOrganisation.name,
                    requestType: "Termination",
                    isChange: serviceAccount.isChange,
                    ispNotification: true,
                    fnoNotification: true,
                    ispContactName: null,
                    fnoContactName: this.$store.state.user.name + " " + this.$store.state.user.surname,
                    fromSpeedProfileName: serviceAccount.packagesIsp.packagesFno.speedProfile.downloadMbps +
                        "/" +
                        serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps,
                    fromSpeedProfileId: serviceAccount.packagesIsp.packagesFno.speedProfileId,
                    authenticationType: serviceAccount.authenticationType,
                    pppoeUsername: serviceAccount.pppoeUsername || null,
                    pppoePassword: serviceAccount.pppoePassword || null,
                    IPoEMacAddress: serviceAccount.IPoEMacAddress || null,
                    initialActivation: serviceAccount.initialActivation ?
                        new Date(serviceAccount.initialActivation)
                        .toISOString()
                        .substr(0, 10) : null,
                    fnoActivationDate: serviceAccount.fnoActivationDate ?
                        new Date(serviceAccount.fnoActivationDate)
                        .toISOString()
                        .substr(0, 10) : null,
                    fnoDeactivationDate: serviceAccount.fnoDeactivationDate ?
                        new Date(serviceAccount.fnoDeactivationDate)
                        .toISOString()
                        .substr(0, 10) : null,
                    ispActivationDate: serviceAccount.ispActivationDate ?
                        new Date(serviceAccount.ispActivationDate)
                        .toISOString()
                        .substr(0, 10) : null,
                    ispDeactivationDate: serviceAccount.ispDeactivationDate ?
                        new Date(serviceAccount.ispDeactivationDate)
                        .toISOString()
                        .substr(0, 10) : null,
                    requestedChangeDate: this.changeRequestItem.requestedChangeDate,
                    staticIpv4: serviceAccount.staticIpv4 || null,
                    staticIpv6: serviceAccount.staticIpv6 || null,
                    deviceId: serviceAccount.deviceId,
                    device: serviceAccount.device,
                    deviceBridge: serviceAccount.deviceBridge || null,
                    deviceBridgeId: serviceAccount.deviceBridgeId,
                    isDeleted: false,
                    isActive: true,
                };
                let same = false;
                await this.terminatePreviousList.map((x) => {
                    if (x.serviceAccountId === obj.serviceAccountId) {
                        same = true;
                    }
                });
                if (same === false) {
                    this.terminatePreviousList.push(obj);
                }
            } else if (serviceAccount.terminate === false) {
                let index = this.terminatePreviousList.findIndex(
                    (x) => x.serviceAccountId === serviceAccount.id
                );

                this.terminatePreviousList.splice(index, 1);
                this.submit = false;
            }
        },
        validateMigration() {
            if (this.changeRequestItem.requestType === "Migration") {
                if (
                    this.changeRequestItem.requestedChangeDate &&
                    this.changeRequestItem.migrationLocation
                ) {
                    return true;
                    //  if(this.serviceAccount.device.Handle_ID!==null&&this.serviceAccount.device.Handle_ID!==0){
                    //    if(this.noZhoneDeviceOnLocation===false){
                    //        if(this.previousAccountsList.length!==this.terminatePreviousList.length){
                    //        return false
                    //      }else{
                    //        return true
                    //      }
                    //    }else{
                    //      return false
                    //    }
                    //  }
                    //  if(this.serviceAccount.device.acsDevice===true){
                    //    if(this.noAcsDeviceOnLocation===false){
                    //        if(this.previousAccountsList.length!==this.terminatePreviousList.length){
                    //        return false
                    //      }else{
                    //        return true
                    //      }
                    //    }else{
                    //      return false
                    //    }
                    //  }
                } else {
                    return false;
                }
            } else {
                if (this.changeRequestItem.requestedChangeDate) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        attachLocation(location) {
            this.changeRequestItem.migrationLocation = location;
            this.migrationLocationSet = true;
            this.attachLocationModal = false;
        },
        fetchNetworks() {
            this.networks = [];
      Api().get('/customer/locationNetwork/basic/'+this.serviceAccount.organisationId).then(res=>{
        this.networks = res.data
      })
            // this.networks = [];
            // Api()
            //     .get("/customer/ispLocationNetwork")
            //     .then(async (response) => {
            //         let tempArr = [];
            //         this.networks = [];
            //         let duplicates = await response.data.map((x) => ({
            //             id: x.locationNetwork.id,
            //             name: x.locationNetwork.name,
            //         }));
            //         for (let k = 0; k < duplicates.length; k++) {
            //             let find = tempArr.find((x) => x === duplicates[k].id);
            //             if (!find) {
            //                 tempArr.push(duplicates[k].id);
            //                 this.networks.push({
            //                     id: duplicates[k].id,
            //                     name: duplicates[k].name,
            //                 });
            //             }
            //         }
            //     });
        },
        terminatePreviousAccounts() {
            for (let k = 0; k < this.terminatePreviousList.length; k++) {
                Api().post("/serviceAccountsAuditLog", this.terminatePreviousList[k]);
            }
        },
        reactivationRequest() {
            this.changeRequestItem = {
                requestType: 'Reactivation',
                organisationBridgeTemplateId: this.bridgeTemplates.length > 0 ? this.bridgeTemplates[0].id : null
            }
            this.reactivationModal = true
        },
        SubmitReactivation() {

        },
        async suspendServices(item) {
            // if (this.authAdmin(this.$store.state.currentRoute)) {
                this.suspendDialog = true
                this.suspendItem = item
                this.suspendItem.type = 'U2000'
            // }

        },
        async submitSuspend() {
            let obj = {
                serviceAccountId: this.suspendItem.id,
                locationId: this.suspendItem.locationId,
                circuitNumber: this.suspendItem.circuitNumber,
                device: this.suspendItem.device,
                deviceBridgeId: this.suspendItem.deviceBridgeId,
                deviceBridge: this.suspendItem.deviceBridge,
                type: 'U2000',
                organisationId: this.suspendItem.supplierOrganisationId,
                customerOrganisationId: this.$store.state.currentOrg.org.id,
                dueDate: this.suspendItem.dueDate
            }
            await Api().post('/serviceAccounts/suspendServices/' + this.suspendItem.id, obj).then(res => {
                this.getServiceAccountDetails()
                this.getTickets()
                this.suspendDialog = false
            })
        },
        async reactivateServices(item) {
            // if (this.authAdmin(this.$store.state.currentRoute)) {
                let obj = {
                    serviceAccountId: item.id,
                    locationId: item.locationId,
                    circuitNumber: item.circuitNumber,
                    device: item.device,
                    deviceBridgeId: item.deviceBridgeId,
                    deviceBridge: item.deviceBridge,
                    organisationId: item.supplierOrganisationId,
                    customerOrganisationId: this.$store.state.currentOrg.org.id,
                    type: 'U2000'
                }
                await Api().post('/serviceAccounts/reactivateServices/' + item.id, obj).then(res => {
                    this.getServiceAccountDetails()
                    this.getTickets()
                })
            // }
        },
        async suspendZhoneServices(item) {
            if (this.authAdmin(this.$store.state.currentRoute)) {
                this.suspendDialog = true
                this.suspendItem = item
                this.suspendItem.type = 'Zhone'

            }
        },
        async submitZhoneSuspend() {
            let obj = {
                serviceAccountId: this.suspendItem.id,
                locationId: this.suspendItem.locationId,
                circuitNumber: this.suspendItem.circuitNumber,
                device: this.suspendItem.device,
                deviceBridgeId: this.suspendItem.deviceBridgeId,
                deviceBridge: this.suspendItem.deviceBridge,
                type: 'Zhone',
                organisationId: this.suspendItem.supplierOrganisationId,
                customerOrganisationId: this.$store.state.currentOrg.org.id,
                dueDate: this.suspendItem.dueDate
            }
            await Api().post('/serviceAccounts/suspendServices/' + this.suspendItem.id, obj).then(res => {
                this.getServiceAccountDetails()
                this.getTickets()
                this.suspendDialog = false
            })
        },
        ispVerifyModal() {
            if (this.bridgeTemplates.length == 0) {
                confirm("You do not have any configuration templates for this make. Please set this up with the relevant Fibre Network Operator.")
            } else {

                if (this.serviceAccount.device) {
                    let selectedTemplates = []
                    if (this.serviceAccount.device.deviceMakeModel.oneDevicePolicy && this.serviceAccount.device.deviceMakeModel.twoDevicePolicy) {
                        selectedTemplates = this.bridgeTemplates.filter(x => x.type == 'OneDevice' || x.type == 'TwoDevice')
                    } else if (this.serviceAccount.device.deviceMakeModel.oneDevicePolicy && !this.serviceAccount.device.deviceMakeModel.twoDevicePolicy) {
                        selectedTemplates = this.bridgeTemplates.filter(x => x.type == 'OneDevice')
                    } else if (!this.serviceAccount.device.deviceMakeModel.oneDevicePolicy && this.serviceAccount.device.deviceMakeModel.twoDevicePolicy) {
                        selectedTemplates = this.bridgeTemplates.filter(x => x.type == 'TwoDevice')
                    }
                    if (selectedTemplates.length == 0) {
                        confirm("You do not have any configuration templates that match the available policies for this device model. Please contact the Fibre Network Operator to rectify this issue.")
                    } else {
                        if (selectedTemplates.length > 0) {
                            this.configurationSettings = {
                                type: 'Multiple',
                                bridgeTemplates: selectedTemplates,
                                selectedTemplateId: selectedTemplates[0].id,
                                connectionType: selectedTemplates[0].connectionType
                            }
                            if (selectedTemplates.length > 1 || this.configurationSettings.connectionType.toLowerCase() == 'pppoe') {
                                this.configModal = true
                            } else {
                                this.reactivateZhoneServices(this.serviceAccount)
                            }
                        }
                    }
                }
            }

        },
        async reactivateZhoneServices() {
            let obj = {
                serviceAccountId: item.id,
                locationId: item.locationId,
                circuitNumber: item.circuitNumber,
                device: item.device,
                organisationId: item.supplierOrganisationId,
                customerOrganisationId: this.$store.state.currentOrg.org.id,
                downloadMbps: item.packagesFno.speedProfile.downloadMbps,
                uploadMbps: item.packagesFno.speedProfile.uploadMbps,
                organisationBridgeTemplateId: this.configurationSettings.selectedTemplateId,
                serviceAccountType: this.configurationSettings.connectionType,
                pppoeUsername: this.configurationSettings.pppoeUsername,
                pppoePassword: this.configurationSettings.pppoePassword,
                type: 'Zhone'
            }
            await Api().post('/serviceAccounts/reactivateServices/' + item.id, obj).then(res => {
                this.getServiceAccountDetails()
                this.getTickets()
            })
        },
        terminateCurrentCreateNew() {
            let obj = {
                status: "Pending",
                serviceAccountId: this.$route.params.serviceAccountId,
                serviceAccountIdentifier: this.serviceAccount.serviceAccountIdentifier,
                locationId: this.serviceAccount.locationId,
                migrationLocationId: this.changeRequestItem.migrationLocation.id || null,
                packagesIspId: this.serviceAccount.packagesIspId,
                locationDescription: this.serviceAccount.location.locationDescription,
                customerOrganisationId: this.serviceAccount.packagesIsp
                    .customerOrganisationId,
                organisationId: this.serviceAccount.organisationId,
                ispName: this.serviceAccount.customerOrganisation.name,
                requestType: "Migration",
                isChange: this.serviceAccount.isChange,
                ispNotification: true,
                fnoNotification: true,
                ispContactName: null,
                fnoContactName: this.$store.state.user.name + " " + this.$store.state.user.surname,
                fromSpeedProfileName: this.serviceAccount.packagesIsp.packagesFno.speedProfile
                    .downloadMbps +
                    "/" +
                    this.serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps,
                fromSpeedProfileId: this.serviceAccount.packagesIsp.packagesFno
                    .speedProfileId,
                authenticationType: this.serviceAccount.authenticationType,
                pppoeUsername: this.serviceAccount.pppoeUsername || null,
                pppoePassword: this.serviceAccount.pppoePassword || null,
                IPoEMacAddress: this.serviceAccount.IPoEMacAddress || null,
                initialActivation: this.serviceAccount.initialActivation ?
                    new Date(this.serviceAccount.initialActivation)
                    .toISOString()
                    .substr(0, 10) : null,
                fnoActivationDate: this.serviceAccount.fnoActivationDate ?
                    new Date(this.serviceAccount.fnoActivationDate)
                    .toISOString()
                    .substr(0, 10) : null,
                fnoDeactivationDate: this.serviceAccount.fnoDeactivationDate ?
                    new Date(this.serviceAccount.fnoDeactivationDate)
                    .toISOString()
                    .substr(0, 10) : null,
                ispActivationDate: this.serviceAccount.ispActivationDate ?
                    new Date(this.serviceAccount.ispActivationDate)
                    .toISOString()
                    .substr(0, 10) : null,
                ispDeactivationDate: this.serviceAccount.ispDeactivationDate ?
                    new Date(this.serviceAccount.ispDeactivationDate)
                    .toISOString()
                    .substr(0, 10) : null,
                requestedChangeDate: this.changeRequestItem.requestedChangeDate,
                staticIpv4: this.serviceAccount.staticIpv4 || null,
                staticIpv6: this.serviceAccount.staticIpv6 || null,
                deviceId: this.serviceAccount.deviceId,
                deviceBridgeId: this.serviceAccount.deviceBridgeId,
                isDeleted: false,
                isActive: true,
            };
            Api()
                .post("/serviceAccountsAuditLog", obj)
                .then(async (response) => {
                    this.getChangeRequests();
                    this.getTickets();
                    this.changeRequestModal = false;
                });
        },
        testSpeed() {
            this.visibleDownload = true;
            Api()
                .get(
                    "/acs/speedTest/download/" +
                    this.serviceAccount.device.ponMac +
                    "/" +
                    this.serviceAccount.device.id
                )
                .then((response) => {
                    this.downloadSpeed = response.data.downloadSpeed;
                    if (response.data.message === "OK") {
                        this.visibleDownload = false;
                        if (response.data.downloadSpeed === null) {
                            this.showDownloadError = true;
                        } else {
                            this.showDownloadError = false;
                        }
                    } else {
                        this.downloadSpeed = 0;
                        this.showDownloadError = true;
                        this.visibleDownload = false;
                    }
                    this.visibleUpload = true;
                    //this.loader.hide()

                    Api()
                        .get(
                            "/acs/speedTest/upload/" +
                            this.serviceAccount.device.ponMac +
                            "/" +
                            this.serviceAccount.device.id
                        )
                        .then((response) => {
                            this.uploadSpeed = response.data.uploadSpeed;
                            if (response.data.message === "OK") {
                                this.visibleUpload = false;
                                if (response.data.uploadSpeed === null) {
                                    this.showUploadError = true;
                                } else {
                                    this.showUploadError = false;
                                }
                            } else {
                                this.uploadSpeed = 0;
                                this.showUploadError = true;
                                this.visibleUpload = false;
                            }
                        });
                });
        },
        clearTemplate() {
            this.ticketItem.dueDate = "";
            this.ticketItem.dueTime = "";
            this.ticketItem.assignedToId = null;
            this.ticketItem.ticketCategoryItemId = null;
            this.ticketItem.ticketCategoryId = null;
        },
        populateTemplate() {
            this.clearTemplate();
            for (let i = 0; i < this.ticketTemplates.length; i++) {
                if (this.ticketTemplates[i].id === this.ticketItem.ticketTemplateId) {
                    this.ticketItem.dueDate = this.ticketTemplates[i].dueDate;
                    this.ticketItem.dueTime = this.ticketTemplates[i].dueTime;
                    this.ticketItem.assignedToId = this.ticketTemplates[i].contactId;
                    if (this.ticketTemplates[i].ticketCategoryItem !== null) {
                        this.ticketItem.ticketCategoryItemId = this.ticketTemplates[
                            i
                        ].ticketCategoryItemId;
                        this.ticketItem.ticketCategoryId = this.ticketTemplates[
                            i
                        ].ticketCategoryItem.ticketCategoryId;
                    }
                }
            }
        },
        addTicket(date) {
            if (date == null) {
                this.addTicketModal = true;
                this.ticketItem = {
                    importance: "Normal",
                    currentStatus: "Pending",
                    dueDate: this.formatDate(new Date()),
                };
            } else {
                this.ticketItem = {
                    importance: "Normal",
                    currentStatus: "Pending",
                    dueDate: this.formatDate(new Date(date)),
                };
                this.addTicketModal = true;
            }
        },
        fetchTicketCategories() {
            Api()
                .get("/isp/ticketCategory")
                .then((response) => {
                    this.ticketCategories = response.data;
                });
        },
        fetchTicketCategoryItems() {
            Api()
                .get("/isp/ticketCategoryItem")
                .then((response) => {
                    this.ticketCategoryItems = response.data;
                });
        },
        async createNewTicket() {
            this.ticketItem.serviceAccountId = this.$route.params.serviceAccountId;
            await Api()
                .post("/ticket", this.ticketItem)
                .then((response) => {
                    this.key++;
                    if (this.ticketCommentLog.length > 0) {
                        for (let i = 0; i < this.ticketCommentLog.length; i++) {
                            this.ticketCommentLog[i].ticketId = response.data.id;
                        }
                        Api()
                            .post("/ticketComment", {
                                batch: this.ticketCommentLog,
                            })
                            .then((response) => {});
                    }
                    if (this.ticketItem.assignedToId) {
                        Api().post("/ticketAssignLog", {
                            assignedToId: this.ticketItem.assignedToId,
                            assignedById: this.$store.state.user.id,
                            ticketId: response.data.id,
                        });
                    }
                    this.getTickets();
                    this.addTicketModal = false;
                    this.ticketItem = {};
                });
        },
        fetchOrgContacts() {
            this.filteredUsers = [];
            Api()
                .get("/organisationContact")
                .then(async (response) => {
                    this.filteredUsers = response.data.filter(function (el) {
                        return el.userType !== "endClient";
                    });
                    let contactArray = await this.filteredUsers.map((x) => x.contact);
                    this.filteredUsers = contactArray;
                });
        },
        addComment(comment) {
            this.ticketCommentLog.push({
                commentedBy: this.$store.state.user,
                commentedById: this.$store.state.user.id,
                comment: comment,
                type: "comment",
                createdAt: new Date(),
            });
            this.comment = "";
            this.addCommentBox = false;
        },
        fetchTicketTemplates() {
            Api()
                .get("/ticketTemplate")
                .then((response) => {
                    this.ticketTemplates = response.data;
                });
        },
        formatDateTime(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd HH:MM");
            } else {
                null;
            }
        },
        addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result.toISOString().substr(0, 10);
        },
        addWifiProfileModal() {
            if (this.authCreate(this.$store.state.currentRoute)) {
                this.wifiItem = {
                    type: "ADD",
                    ssid: "",
                    password: "",
                    channel: 0,
                    encryption: "WPA2",
                    enable: true,
                    hidden: false,
                    frequencyBand: this.availableFrequency[0],
                    deviceBridgeId: this.serviceAccount.deviceBridgeId,
                    customerOrganisationId: this.serviceAccount.customerOrganisationId,
                };
                this.addWifiProfileItem = true;
            }
        },
        denyRequestItem(item) {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                this.denyItem = Object.assign({}, item);
                this.denyRequestModal = true;
            }
        },
        openCancelRequestConfirmation(item) {
            this.changeRequestItemToCancel = item;
            this.cancelRequestItemConfirmation = true;
        },
        async cancelRequestItem() {
            this.loadingCancelChangeRequest = true;
            // Cancel Request
            await Api().put('/serviceAccountsAuditLog/isp/cancel/changeRequest/' + this.changeRequestItemToCancel.id, {
                status: 'Canceled',
                isActive: false,
                // rejectedById: this.$store.state.user.id // Need to add 'rejectedById' field to DB
            })
            // Update Service Account To Remove Deactivcation Dates (account is no longer being terminated/deactivated)
            await Api().put('/serviceAccounts/' + this.$route.params.serviceAccountId, {
                ispDeactivationDate: null,
                fnoDeactivationDate: null
            })
            this.getChangeRequests();
            this.getServiceAccountHistory();
            this.cancelRequestItemConfirmation = false;
            this.loadingCancelChangeRequest = false;
        },
        async getActiveISPPackages() {
            await Api()
                .get(
                    "/customer/packagesIsps/byNetwork/active/" +
                    this.serviceAccount.location.locationNetworkId
                )
                .then((response) => {
                    this.allIspPackages = response.data.activePackages
                    this.allIspPackages.map((x) => {
                        x.customerOrganisation = response.data.organisations.find(y => y.id == x.customerOrganisationId)
                    });
                    this.keyPackages++
                });
        },
        async destroyed() {
            await this.clearIntervalListener(this.setIntervalId);
            source.cancel("Operation canceled by the user.");
        },
        getU2000OnuStatus(obj) {
            Api().get('/u2000/ontStatus/' + this.serviceAccount.supplierOrganisationId, {
                params: {
                    deviceName: obj.upstreamDevice.systemName,
                    frameId: obj.frame,
                    slotId: obj.slot,
                    portId: obj.port,
                    onuId: obj.ponId
                }
            }).then(res => {
                this.deviceDetail.status = {}
                this.deviceDetail.status.isOnline = res.data.data.RUNSTAT == 'Up' ? true : false
                this.deviceDetail.status.uptime = new Date(res.data.data.LSTUPTIME)
                this.deviceDetail.status.lastDowntime = new Date(res.data.data.LSTDOWNTIME)
                this.deviceDetail.status.lastDownCause = res.data.data.LSTDOWNCAUSE
                this.onuKey += 1
            })
        },
        async getServiceAccountDetails() {
            await Api()
                .get("/customer/serviceAccounts/" + this.$route.params.serviceAccountId)
                .then((response) => {
                    this.serviceAccount = response.data;
                    // if(response.data.device.isU2000){
                    // this.populateRequestTypes = ['Upgrade','Downgrade','Migration', 'Termination']
                    // }else{
                    this.populateRequestTypes = ['Upgrade', 'Downgrade', 'Termination']
                    if (this.serviceAccount.authenticationType.toLowerCase() === 'pppoe') {
                        this.populateRequestTypes.push('PPPoE Details Update')
                    }
                    // }
                    this.maxDownload = response.data.packagesIsp.packagesFno.speedProfile.downloadMbps * 1.5
                    this.maxUpload = response.data.packagesIsp.packagesFno.speedProfile.uploadMbps * 1.5
                    if (this.serviceAccount.device) {
                        this.getAvailableTemplates(
                            this.serviceAccount.device.deviceMakeModel.deviceMakeId
                        );
                    }

                    if (this.serviceAccount.device && this.serviceAccount.device.isU2000) {
                        this.getU2000OnuStatus(this.serviceAccount.device)
                    } else if (this.serviceAccount.deviceId && this.serviceAccount.device && this.serviceAccount.device.Handle_ID !== null && this.serviceAccount.device.Handle_ID > 0) {
                        this.onuStatus.complete = true
                        //  debugger
                        this.setIntervalId = setInterval(() => {
                            this.getOnuStatus(this.serviceAccount.device.Handle_ID);
                        }, 5000);
                    }
                    // Non-Zhone/Huawei ONTs (e.g. Jackal Creek BDCOM): status kept current by DeviceSync_NMS every 5 minutes.
                    const dev = this.serviceAccount.device
                    if (dev && !dev.isU2000 && !(dev.Handle_ID > 0) && dev.isOnline !== null && dev.isOnline !== undefined) {
                        this.deviceDetail = { status: { isOnline: !!dev.isOnline, checkedAt: dev.lastOnlineUpdate } }
                        this.onuKey++
                    }
                    if (this.serviceAccount.deviceBridge) {
                        this.internetServices = [this.serviceAccount.deviceBridge]
                    }

                });
        },
        // async getServiceAccountHistory() {
        //     await Api()
        //         .get(
        //             "/customer/serviceAccounts/allByIdentifier/" +
        //             this.serviceAccount.serviceAccountIdentifier
        //         )
        //         .then((response) => {
        //             this.allServiceAccountHistory = response.data;
        //             this.serviceAccountHistory = this.allServiceAccountHistory.slice(
        //                 0,
        //                 2
        //             );
        //         });
        // },
        async getServiceAccountHistory() {
            await Api()
                .get(
                    "/customer/serviceAccounts/history/allByIdentifier/" +
                    this.serviceAccount.serviceAccountIdentifier
                )
                .then(response => {
                    this.allServiceAccountHistory = response.data
                    console.log(this.allServiceAccountHistory)
                    // this.serviceAccountHistory = this.allServiceAccountHistory.slice(0, 2);
                });
        },
        async getChangeRequests() {
            await Api()
                .get(
                    "/isp/serviceAccountsAuditLog/byServiceAccountId/" +
                    this.$route.params.serviceAccountId
                )
                .then((response) => {
                    this.allPendingRequests = response.data.filter(
                        // (x) => x.status != "Denied" && x.status != "Resolved"
                        (x) => x.status != "Denied" && x.status != "Resolved" && x.status != "Canceled"
                    );
                    this.pendingRequests = this.allPendingRequests.slice(0, 1);

                    this.allResolvedRequests = response.data.filter(
                        // (x) => x.status == "Denied" || x.status == "Resolved"
                        (x) => x.status == "Denied" || x.status == "Resolved" || x.status == "Canceled"
                    );
                    this.resolvedRequests = this.allResolvedRequests.slice(0, 1);
                });
        },
        async routeToTicketSummary(id) {
            this.$router.push({
                path: "/ispTicketSummary/" + id
            });
        },
        async getTickets() {
             await Api().get('/customer/ticket/byServiceAccount/' + this.$route.params.serviceAccountId)
                .then((response) => {
                    this.allOpenTickets = response.data.filter((x) => !x.isComplete);
                    this.allResolvedTickets = response.data.filter((x) => x.isComplete);
                    this.pendingTickets = this.allOpenTickets.slice(0, 1);
                    this.resolvedTickets = this.allResolvedTickets.slice(0, 1);
                });
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd");
            } else {
                null;
            }
        },
        async logServiceAccountChange(item) {
            if (item.requestType !== 'PPPoE Details Update') {
                let toSpeedId = null;
                let toSpeedName = null;
                let toPackageId = null;
                if (item.requestType === "Migration") {
                    this.terminatePreviousAccounts();
                    this.terminateCurrentCreateNew();
                }
                if (
                    item.requestType !== "Termination" &&
                    item.requestType !== "Migration" &&
                    item.toPackage
                ) {
                    toSpeedId = item.toPackage.packagesFno.speedProfileId;
                    toSpeedName =
                        item.toPackage.packagesFno.speedProfile.downloadMbps +
                        "/" +
                        item.toPackage.packagesFno.speedProfile.uploadMbps;
                    toPackageId = item.toPackage.id;
                }
                if (item.requestType !== "Migration") {
                    let obj = {
                        status: "Pending",
                        serviceAccountId: this.$route.params.serviceAccountId,
                        serviceAccountIdentifier: this.serviceAccount
                            .serviceAccountIdentifier,
                        locationId: this.serviceAccount.locationId,
                        migrationLocationId: this.migrationLocationId || null,
                        packagesIspId: this.serviceAccount.packagesIspId,
                        locationDescription: this.serviceAccount.location.locationDescription,
                        organisationId: this.serviceAccount.supplierOrganisationId,
                        customerOrganisationId: this.serviceAccount.packagesIsp
                            .customerOrganisationId,
                        ispName: this.$store.state.currentOrg.org.name,
                        requestType: item.requestType,
                        isChange: this.serviceAccount.isChange,
                        ispNotification: true,
                        fnoNotification: true,
                        ispContactName: null,
                        fnoContactName: this.$store.state.user.name + " " + this.$store.state.user.surname,
                        fromSpeedProfileName: this.serviceAccount.packagesIsp.packagesFno.speedProfile
                            .downloadMbps +
                            "/" +
                            this.serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps,
                        fromSpeedProfileId: this.serviceAccount.packagesIsp.packagesFno
                            .speedProfileId,
                        toSpeedProfileId: toSpeedId,
                        toSpeedProfileName: toSpeedName,
                        toPackageId: toPackageId,
                        organisationBridgeTemplateId: this.changeRequestItem.organisationBridgeTemplateId,
                        oldServiceAccountId: this.serviceAccount.id,
                        authenticationType: this.serviceAccount.authenticationType,
                        pppoeUsername: this.serviceAccount.pppoeUsername || null,
                        pppoePassword: this.serviceAccount.pppoePassword || null,
                        IPoEMacAddress: this.serviceAccount.IPoEMacAddress || null,
                        initialActivation: this.serviceAccount.initialActivation ?
                            new Date(this.serviceAccount.initialActivation)
                            .toISOString()
                            .substr(0, 10) : null,
                        fnoActivationDate: this.serviceAccount.fnoActivationDate ?
                            new Date(this.serviceAccount.fnoActivationDate)
                            .toISOString()
                            .substr(0, 10) : null,
                        fnoDeactivationDate: this.serviceAccount.fnoDeactivationDate ?
                            new Date(this.serviceAccount.fnoDeactivationDate)
                            .toISOString()
                            .substr(0, 10) : null,
                        ispActivationDate: this.serviceAccount.ispActivationDate ?
                            new Date(this.serviceAccount.ispActivationDate)
                            .toISOString()
                            .substr(0, 10) : null,
                        ispDeactivationDate: this.serviceAccount.ispDeactivationDate ?
                            new Date(this.serviceAccount.ispDeactivationDate)
                            .toISOString()
                            .substr(0, 10) : null,
                        requestedChangeDate: item.requestedChangeDate,
                        staticIpv4: this.serviceAccount.staticIpv4 || null,
                        staticIpv6: this.serviceAccount.staticIpv6 || null,
                        deviceId: this.serviceAccount.deviceId,
                        deviceBridgeId: this.serviceAccount.deviceBridgeId,
                        isDeleted: false,
                        isActive: true,
                    };
                    Api()
                        .post("/serviceAccountsAuditLog", obj)
                        .then(async (response) => {
                            obj.serviceAccountAuditLogId = response.data.id;
                            this.getChangeRequests();
                            this.changeRequestModal = false;
                            this.changeRequestItem = {};
                            this.reactivationModal = false

                        })
                        .catch((err) => {
                            this.errorSnackbar = true;
                            this.text = (err.response && err.response.data && err.response.data.message) || 'Unable to log change request.';
                        });
                }
            } else {
                let obj = {
                    currentStatus: 'Pending',
                    importance: 'Average',
                    isComplete: false,
                    serviceAccountId: this.serviceAccount.id,
                    deviceId: this.serviceAccount.deviceId,
                    createdById: this.$store.state.user.id,
                    customerOrganisationId: this.serviceAccount.customerOrganisationId,
                    organisationId: this.serviceAccount.supplierOrganisationId,
                    description: 'Update PPPoE Account Details: Username: ' + this.changeRequestItem.pppoeUsername + ' | Password: ' + this.changeRequestItem.pppoePassword,
                    ticketCategoryItemId: 55,
                    dueDate: item.requestedChangeDate,
                    isActive: true,
                    isDeleted: false
                }
                await Api().put('/customer/serviceAccounts/' + this.serviceAccount.id, {
                    pppoeUsername: this.changeRequestItem.pppoeUsername,
                    pppoePassword: this.changeRequestItem.pppoePassword
                })
                await Api().post('/ticketIsp', obj).then(res => {
                    this.changeRequestModal = false;
                    this.changeRequestItem = {};
                    this.snackbar = true
                    this.text = 'Successfully logged request!'
                    this.getTickets()
                })
            }
            this.getServiceAccountHistory()
        },

        async saveWifiProfile() {
            if (this.wifiItem.type === "ADD") {
                await Api()
                    .post("/acs/createWifi", {
                        ssid: this.wifiItem.ssid,
                        password: this.wifiItem.password,
                        channel: this.wifiItem.channel,
                        encryption: this.wifiItem.encryption,
                        enable: this.wifiItem.enable,
                        hidden: this.wifiItem.hidden,
                        frequency: this.wifiItem.frequencyBand,
                        ponMac: this.serviceAccount.device.ponMac,
                        customerOrganisationId: this.wifiItem.customerOrganisationId,
                    })
                    .then(async (response) => {
                        if (response.data.code === 200) {
                            await Api()
                                .post("/deviceWifi", {
                                    ssid: this.wifiItem.ssid,
                                    password: this.wifiItem.password,
                                    channel: this.wifiItem.channel,
                                    encryption: this.wifiItem.encryption,
                                    enable: this.wifiItem.enable,
                                    hidden: this.wifiItem.hidden,
                                    frequencyBand: this.wifiItem.frequencyBand,
                                    deviceId: this.serviceAccount.deviceId,
                                    deviceBridgeId: this.serviceAccount.deviceBridgeId,
                                    customerOrganisationId: this.wifiItem.customerOrganisationId,
                                    isActive: true,
                                    isDeleted: false,
                                })
                                .then((response) => {
                                    this.wifiServices.push(response.data);
                                    this.snackbar = true;
                                    this.text = response.data.message;
                                });
                        } else {
                            this.errorSnackbar = true;
                            this.text = response.data.message;
                        }
                        this.wifiItem = {};
                        this.addWifiProfileItem = false;
                        let index = this.availableFrequency.find(
                            (x) => x == this.wifiItem.frequency
                        );
                        this.availableFrequency.splice(index, 1);
                    });
            } else if (this.item.type === "EDIT") {
                await Api()
                    .post("/acs/updateWifi", {
                        ssid: this.wifiItem.ssid,
                        password: this.wifiItem.password,
                        channel: this.wifiItem.channel,
                        encryption: this.wifiItem.encryption,
                        enable: this.wifiItem.enable,
                        hidden: this.wifiItem.hidden,
                        frequency: this.wifiItem.frequencyBand,
                        ponMac: this.device.ponMac,
                        customerOrganisationId: this.item.customerOrganisationId,
                    })
                    .then((response) => {
                        Api()
                            .put("/deviceWifi/" + this.wifiItem.id, {
                                ssid: this.wifiItem.ssid,
                                password: this.wifiItem.password,
                                channel: this.wifiItem.channel,
                                encryption: this.wifiItem.encryption,
                                enable: this.wifiItem.enable,
                                hidden: this.wifiItem.hidden,
                                frequencyBand: this.wifiItem.frequencyBand,
                                isActive: true,
                                isDeleted: false,
                            })
                            .then(async (response) => {
                                let find = await this.item.deviceWifis.find(
                                    (x) => x.id === this.wifiItem.id
                                );
                                if (find) {
                                    let index = this.item.deviceWifis.indexOf(find);
                                    this.item.deviceWifis[index] = response.data;
                                }
                                this.wifiItem = {};
                                this.wifiKey += 1;
                                this.addWifiProfileItem = false;
                            });
                    });
            }
        },
    },
};
</script>

<style scoped>
.card-outter {
    position: relative;
    padding-bottom: 50px;
}

.card-actions {
    position: absolute;
    bottom: 0;
    align-content: "center";
    justify-content: "center";
}
</style>
